import React, { useEffect, useState, useCallback, useMemo } from 'react'
import Constants from 'expo-constants'
import {
    Text,
    Image,
    View,
    FlatList,
    TouchableOpacity,
    Dimensions,
    Alert,
    StatusBar,
    Linking,
    PixelRatio,
    ActivityIndicator,
    Animated,
} from 'react-native'
import { FlashList } from '@shopify/flash-list'
import NetInfo from '@react-native-community/netinfo'
import { StackNavigationProp, StackScreenProps } from '@react-navigation/stack'
import { DotsNavigation } from '../navigation/stacks/NavigationStack'
import { fetchAuthSession } from 'aws-amplify/auth'
import { DataSheetModel, FormsModel, KpisIndicators, PerfectStoreModel, StoreAdditionalInfo, StoreDetailModel } from './models/StoreDetailModel'
import { BenefitItemModel } from '../benefits/models/BenefitItemModel'
import styles from './StoreDetailStyles'
import stylesSchedules from './ScheduleStyles'
import stylesCampaingView from './CampaignViewStyles'
import stylesScheduleDistributor from './ScheduleDistributorStyles'
import { openDB } from '../../db/indexDB'
import { EvilIcons, Feather, Ionicons } from '@expo/vector-icons'
import { getForms, getStores } from '../../db/posSchedules'
import { FormView } from './ExecutionView'
import { useNavigation } from '@react-navigation/native'
import * as Progress from 'react-native-progress'
import { placeholderGeneral } from '../customUtils/Constants'
import { LinearGradient } from 'expo-linear-gradient'
import theme from '../../../theme'
import { ScrollView } from 'react-native-gesture-handler'
import { request_checkin, request_checkout, request_get_store } from '../../services/schedule.services'
import { schedulesServices } from '../../../database/schedules.database'
import { addOrUpdateAdvanceSchedule } from '../../../db-sqlite/repositories/schedule.repository'
import { getLocation } from '../appBar/context/LocationContext'
import { CONSTANTS_TYPES_STEPS, FORM_SCHEDULE_STATUS, FORM_TYPES, ID_DROPDOWN_USERS, STORE_STATUS } from './constants/constants.stores'
import { FormProps, useFormContext, useFormRefrigeratorContext } from './context/form.context'
import { Loader } from '../customUtils/Components/Loader'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { FormSteps } from './FormSteps'
import { CampaignStatus } from './StatusTagsStores'
import { BottomSheetAlert } from '../modals/BottomSheetAlert'
import { useStoreContext } from './context/store.context'
import { ActivitysModel } from './models/ScheduleModel'
import { getDistanceWithTextCal } from '../customUtils/calculateDistance'
import { SecondaryActionFormUsers } from './interfaces/StoreDetail.interface'
import { getConection } from '../appBar/context/HeaderContext'
import { useModerationPeriodStore } from '../../redux/zustand/modarationPeriodStore'
import { useStoreStatusStore } from '../../redux/zustand/storesStatusStore'
import { StoreVouchersList } from './StoreVouchersList'
import {
    captureAndSaveDataError,
    generateIdDateNow,
    hasShowProgress,
    isEntornoTesting,
    isValidMongoId,
    openExternalLink,
    validateConnectionNetwork,
    validateUpdateCoordsTime,
} from '../../utils/functions.utils'
import { useFormView } from './hooks/useFormView'
import { PATH_ASSETS, TRACKINGS_TYPES } from '../../utils/Constants'
import useImageLoader from '../../hooks/useImageLoader'
import { useStepsDistributor } from '../../redux/zustand/stepsDistributorStore'
import { RoundedTabs } from '../customUtils/LinealTabs'
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons'
import { useFormIncidenceStore } from '../../redux/zustand/formIncedenceStore'
import { useSpinAnimation } from '../../hooks/useSpinAnimation'
import { StoreKPIIndicators } from '../customUtils/Components/Indicator'
import { TrackingServices } from '../../../database/tracking.database'
import { platformSelect } from '../../utils/platformUtils'

interface Props extends StackScreenProps<DotsNavigation, 'StoreDetail'> {}

const { width } = Dimensions.get('window')

const CHECKIN_PENDIENTE = 0
const CHECKIN_REALIZADO = 1
const CHECKOUT_REALIZADO = 3

export const StoreDetail = React.memo(({ route }: Props) => {
    // console.log('me vuelvo a renderizar ?? StoreDetail')
    const { storeID, forms, scheduleID, steps, forms_relevant, forms_advances, distance, store_status, navigate_form, incidence_answer } =
        route.params

    const expoConfig = Constants.expoConfig || { slug: '' }
    const fontScale = 1
    const iconSizeMin = 14 * fontScale

    const { formsContext, setFormsContext, setReloadChange, setCurrentCheckin, updateStatusForm } = useFormContext()
    const memorizedForms = useMemo(() => formsContext, [formsContext])
    const { sendForm } = useFormView({})
    const { updateStoreStatus, stores, reloadForms } = useStoreContext()
    const { set_form_refrigerators_main, set_forms_refrigerators } = useFormRefrigeratorContext()
    const { userLat, userLng, askAgain, lastUpdateCoorsUser, checkLocation } = getLocation()

    const { languageFile } = getLanguage()
    const { isConnected, hasInternet } = getConection()

    const [status_store, setStatus_store] = useState(store_status)
    const [buttonIncidenceText, setButtonIncidenceText] = useState<String | null>(incidence_answer)
    const [checkInID, setCheckinID] = useState('')
    const [checkInIDLocal, setCheckinIDLocal] = useState('')
    const [vouchers, setVouchers] = useState<BenefitItemModel[]>([])
    const [store, setStoreInfo] = useState<DataSheetModel>()
    const [perfectStoreArray, setPFA] = useState<PerfectStoreModel[]>([])
    const [showMore, setShowMore] = useState(true)
    const navigation = useNavigation<StackNavigationProp<DotsNavigation>>()
    const [loading, setLoading] = useState(true)
    const { openBottomSheet, closeBottomSheet } = useBottomSheet()
    const [statusCheckin, setStatusCheckin] = useState(0)
    const [isIncidenceReport, setIsIncidenceReport] = useState(
        [STORE_STATUS.INCIDENCE_REPORTED, STORE_STATUS.INCIDENCE_REPORTED_PERMANENTE, STORE_STATUS.INCIDENCE_REPORTED_CLOSE].includes(store_status),
    )
    const [statusSteps, setStatusSteps] = useState(0)
    const [progressRelev, setProgressRelev] = useState(0)
    const [isLoadingPerfectStore, setIsLoadingPerfectStore] = useState(false)
    const [selectedIndex, setSelectedIndex] = useState(0)
    const [showIndicators, setShowIndicators] = useState(false)
    const [checkoutInProcess, setCheckoutInProcess] = useState(false)
    const [iconSize, setIconSize] = useState(20)
    const [loadingCheckin, setLoadingCheckin] = useState<boolean>(false)
    const [loadingCheckout, setLoadingCheckout] = useState<boolean>(false)
    const [loadingExecution, setLoadingExecution] = useState(false)
    const [validateCheckout, setValidateCheckout] = useState({
        isPosibleCheckout: false,
        messageValidateCheckout: '',
    })
    const [validateCheckin, setValidateCheckin] = useState({
        isPosibleCheckin: true,
        messageValidateCheckin: '',
    })
    const [startAnimationLoaderUbi, setStartAnimationLoaderUbi] = useState(false)

    const spinRefreshUbi = useSpinAnimation(startAnimationLoaderUbi)
    const isUserBlocked = useModerationPeriodStore((state) => state.isUserBlocked)
    const setStepsDistri = useStepsDistributor((state) => state.setSteps)
    const clearStepsDistributor = useStepsDistributor((state) => state.clearSteps)
    const setStoreStatus = useStoreStatusStore((state) => state.setStoreStatus)
    const canFormIncidence = useFormIncidenceStore((state) => state.canFormIncidence)
    const formIncidence = useFormIncidenceStore((state) => state.formIncidence)

    const routes = useMemo(
        () => [
            { key: 'benefits', title: 'Beneficios' },
            { key: 'redimes', title: 'Historial' },
        ],
        [],
    )

    const [tabs, setTabs] = useState([
        {
            name: 'Vouchers',
            index: 0,
        },
        {
            name: 'Canjes',
            index: 1,
        },
    ])

    const fetchDataLocalNew = async () => {
        try {
            const database = await openDB()
            const findStoreContext = stores.find((store) => store._id === storeID)
            const formularios = []
            let newForms = []
            try {
                const details = await schedulesServices.getStore(storeID)
                setData({ data_sheet: details })

                const savedKPIS = await schedulesServices.getStoreKPIS(storeID)
                if (savedKPIS && savedKPIS.length > 0) {
                    setKpis(savedKPIS)
                }

                const answers_response_moderation = []
                const all_forms = []

                if (all_forms && all_forms.length > 0) {
                    all_forms.forEach((form) => {
                        form.status === FORM_SCHEDULE_STATUS.BLOCKED && statusCheckin === CHECKIN_REALIZADO
                            ? (form.status = FORM_SCHEDULE_STATUS.PENDING)
                            : (form.status = form.status),
                            newForms.push(form._id)
                    })

                    await saveFormsHeladeras(all_forms)
                }

                newForms = [...newForms, ...forms]

                if (newForms && newForms.length > 0) {
                    let forms_relevant: ActivitysModel[] = []
                    let forms_featured: ActivitysModel[] = []

                    if (findStoreContext && findStoreContext.forms_relevant && findStoreContext.forms_featured) {
                        forms_relevant = findStoreContext.forms_relevant
                        forms_featured = findStoreContext.forms_featured
                    }

                    try {
                        let status_store = await validateStatusCheckin()

                        console.log('newForms', newForms.length)
                        for (const form_id of newForms) {
                            let answer_response = null
                            if (answers_response_moderation && answers_response_moderation.length > 0) {
                                const filteredForms = answers_response_moderation.filter((form) => form._id.toString() === form_id.toString())
                                if (filteredForms && filteredForms.length > 0) {
                                    answer_response = filteredForms.flatMap((form) =>
                                        form.answers.map((answer) => ({
                                            ...answer,
                                            moderation: form.moderation,
                                        })),
                                    )
                                }
                            }

                            try {
                                const get_form = await schedulesServices.getForm(form_id)
                                if (get_form && filterFormsByDate(get_form)) {
                                    // console.log('get_form', get_form._id, get_form.name_form, get_form.type_form.type)
                                    if (get_form['type_form']['type'] == FORM_TYPES.FORM_REDIRECT) {
                                        //valido si tienen la key link valida
                                        let url = get_form?.link
                                        if (url && url != '') {
                                            const isValidUrl = url && /^https?:\/\/[\w.-]+\.[a-z]{2,}.*$/.test(url)
                                            if (!isValidUrl) {
                                                console.log('URL inválida o no disponible:', url)
                                                return
                                            }
                                        }
                                    }
                                    // console.log('status_store =>', status_store) // 1
                                    let status_form = status_store == CHECKIN_REALIZADO ? FORM_SCHEDULE_STATUS.PENDING : FORM_SCHEDULE_STATUS.BLOCKED
                                    // console.log('1 status_form => ', status_form) // 0
                                    let advance = null
                                    /*
                                        -busca si el formulario tiene un advance que me llega de mongo
                                        sino busca lo que tenga en dbLocal
                                    */
                                    if (forms_advances && forms_advances.length > 0 && forms_advances.find((form) => form._id == form_id)) {
                                        // console.log('227 ---- forms_advances => ', forms_advances)
                                        advance = forms_advances.find((form) => form._id == form_id)
                                        console.log('228 ---- advance ===> :', advance)
                                    } else {
                                        try {
                                            // let get_advance_local = await schedulesServices.getFormsAnswers(scheduleID, form_id, storeID)
                                            let get_advance_local = await schedulesServices.getFormsAnswersInStore(scheduleID, form_id, storeID)
                                            // console.log('231 --- get_advance_local:', get_advance_local)
                                            if (get_advance_local && get_advance_local.status) {
                                                advance = get_advance_local
                                            }
                                        } catch (error) {
                                            console.error('196 --- Error en getFormsAnswers:', error)
                                            const dataCapture = {
                                                log: error,
                                                date: new Date().toISOString(),
                                                end: 'fetchDataLocalNew forof - getFormsAnswers',
                                                additional: JSON.stringify({
                                                    store_id: storeID,
                                                    schedule_id: scheduleID,
                                                    forms: forms,
                                                    form_id: form_id,
                                                    formsContext: formsContext,
                                                }),
                                            }
                                            captureAndSaveDataError(dataCapture)
                                        }
                                    }
                                    if (
                                        advance &&
                                        (status_store == CHECKIN_REALIZADO ||
                                            status_store == CHECKOUT_REALIZADO ||
                                            status_store == CampaignStatus.STATUS_FORM_REFUSED)
                                    ) {
                                        if (get_form['type_form']['type'] !== FORM_TYPES.FORM_POP_HELADERA) {
                                            get_form.progress_questions_yes_na = advance.progress !== '' ? parseInt(advance.progress) : 0
                                            // status_form = FORM_SCHEDULE_STATUS.COMPLETED
                                            status_form = advance.status
                                            console.log('2 status_form => ', status_form)
                                            get_form.complete = true
                                            get_form.scoreObtained = advance.progress !== '' ? parseInt(advance.progress) : 0
                                        }
                                    }
                                    const questions = get_form.contents.map((question) => {
                                        return {
                                            _id: question._id,
                                            title: question.title,
                                            ponderar: question.questionScore && question.questionScore > 0, //[7, 8, 14, 18].includes(question.input_type.type),
                                            questionScore: question.questionScore,
                                            input_type: question.input_type,
                                            secondary_actions: question.secondary_actions,
                                            mandatory: question.mandatory,
                                            score: question.score,
                                        }
                                    })
                                    let form_save = {
                                        schedule_id: scheduleID,
                                        form_id: form_id,
                                        store_id: storeID,
                                        repeat: get_form.repeat,
                                        questions: JSON.stringify(questions) ?? '[]',
                                        progress: get_form.progress,
                                        totalScore: get_form.totalScore,
                                        status: status_form,
                                        scoreObtained: get_form?.scoreObtained || 0,
                                        progress_questions_yes_na: get_form.progress_questions_yes_na || 0,
                                        answers: '[]',
                                        name_form: get_form.name_form,
                                        heladera: get_form.heladera,
                                        create_refrigerator: get_form.create_refrigerator,
                                        type_form: get_form.type_form,
                                        form_id_father: get_form.form_id_father,
                                        checkout: true,
                                        link: get_form.link,
                                        checkin_id: Date.now().toString(),
                                    }
                                    // console.log('form_save.status => ', form_save.status)
                                    if (answer_response && answer_response.length > 0) {
                                        form_save.answers = JSON.stringify(answer_response)
                                    }
                                    const saveFormResponse = await schedulesServices.saveFormAnswers(form_save)

                                    // console.log(
                                    //     `--------- form_id => ${form_id} ~ 0 saveFormResponse ~ saveFormResponse:`,
                                    //     saveFormResponse?.result?._id,
                                    // )

                                    let statusForm = saveFormResponse?.result?.status
                                    const scoreObtained = saveFormResponse?.result?.scoreObtained
                                    const cant_questions_yes_na = saveFormResponse?.result?.cant_questions_yes_na
                                    const progress = saveFormResponse?.result?.progress === 1 ? true : false
                                    const progress_questions_yes_na = saveFormResponse?.result?.progress_questions_yes_na
                                    const form_id_fqa = saveFormResponse?.result?._id
                                    // console.log('')
                                    // console.log('3 status_form => ', status_form)
                                    // console.log('statusCheckin => ', statusCheckin)
                                    // console.log('status_store => ', status_store)
                                    // if (status_form === FORM_SCHEDULE_STATUS.BLOCKED && statusCheckin === CHECKIN_REALIZADO) {
                                    //     status_form = FORM_SCHEDULE_STATUS.PENDING
                                    //     console.log('4 status_form => ', status_form)
                                    // }
                                    if (status_form === FORM_SCHEDULE_STATUS.BLOCKED && status_store === CHECKIN_REALIZADO) {
                                        status_form = FORM_SCHEDULE_STATUS.PENDING
                                        // console.log('4 status_form => ', status_form)
                                    }
                                    formularios.push({
                                        ...get_form,
                                        store_id: storeID,
                                        schedule_id: scheduleID,
                                        status: status_form,
                                        scoreObtained: scoreObtained,
                                        progress: progress,
                                        cant_questions_yes_na: cant_questions_yes_na,
                                        progress_questions_yes_na: progress_questions_yes_na,
                                        mandatory: forms_relevant.some((form) => form?._id == form_id),
                                        featured: forms_featured.some((form) => form?._id == form_id),
                                        form_id_fqa: form_id_fqa,
                                    })
                                }
                            } catch (error) {
                                console.error(`144:   getForm: ${form_id}`, error)
                                const dataCapture = {
                                    log: error,
                                    date: new Date().toISOString(),
                                    end: 'fetchDataLocalNew forof',
                                    additional: JSON.stringify({
                                        store_id: storeID,
                                        schedule_id: scheduleID,
                                        forms: forms,
                                        form_id: form_id,
                                        formsContext: formsContext,
                                    }),
                                }
                                captureAndSaveDataError(dataCapture)
                            }
                        }
                    } catch (error) {
                        const dataCapture = {
                            log: error,
                            date: new Date().toISOString(),
                            end: 'fetchDataLocalNew1',
                            additional: JSON.stringify({ store_id: storeID, schedule_id: scheduleID, forms: forms, formsContext: formsContext }),
                        }
                        captureAndSaveDataError(dataCapture)
                    } finally {
                        formularios.sort((a, b) => a.index_form - b.index_form)
                        verifyShowLoaderExecution(formularios)
                        setFormsContext(formularios)
                    }
                }
            } catch (error) {
                console.error(' ~0 fetchData store ~ error:', error)
                const dataCapture = {
                    log: error.message,
                    date: new Date().toISOString(),
                    end: 'fetchDataLocalNew2',
                    additional: JSON.stringify({ store_id: storeID, schedule_id: scheduleID, forms: forms, formsContext: formsContext }),
                }
                captureAndSaveDataError(dataCapture)
            } //sin conexion
        } catch (error) {
            console.error('Error en fetchDataNew:', error)

            const dataCapture = {
                log: error.message,
                date: new Date().toISOString(),
                end: 'fetchDataLocalNew3',
                additional: JSON.stringify({ store_id: storeID, schedule_id: scheduleID, forms: forms, formsContext: formsContext }),
            }
            captureAndSaveDataError(dataCapture)
        }
    }

    const verifyShowLoaderExecution = async (formularios) => {
        try {
            const questDropdowsn = []
            formularios.forEach((form) => {
                const questions = form.contents
                if (questions && questions.length > 0) {
                    for (const quest of questions) {
                        if (quest.input_type && quest.input_type._id === ID_DROPDOWN_USERS) {
                            questDropdowsn.push(quest)
                            break
                        }
                    }
                }
            })
            if (questDropdowsn.length > 0) {
                setLoadingExecution(true)
            }
        } catch (error) {
            console.error('Error en verifyShowLoaderExecution:', error)
        }
    }

    const fetchDataOnlineNew = async () => {
        try {
            const hasConnection = await validateConnectionNetwork()
            const { existsInDB, _id_mongoDB } = await schedulesServices.getExistsInDB(storeID)

            if (hasConnection && existsInDB) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ""
                // console.log('_id_mongoDB: ', _id_mongoDB, 'storeID: ', storeID, 'scheduleID: ', scheduleID)
                const response = await request_get_store({ authToken, store_id: _id_mongoDB ? _id_mongoDB : storeID, schedule_id: scheduleID })
                if (response && response.status && response.response.status == 1) {
                    let data = response.response
                    // console.log('data => ', JSON.stringify(data))
                    if (data && data.status == 1 && data.single) {
                        // agrego users en el form, actualizo
                        if (data.single.forms_users && data.single.forms_users.length > 0) {
                            await agregateUsersFormDropdown(data.single.forms_users)
                        }
                        setData(data.single).finally(() => {
                            setIsLoadingPerfectStore(false)
                            setLoadingExecution(false)
                        })
                    }
                }
            } else {
                setLoadingExecution(false)
                setIsLoadingPerfectStore(false)
            }
        } catch (error) {
            console.error('Error en fetchDataOnlineNew:', error)
        } finally {
        }
    }

    const loadData = async () => {
        await validateStatusCheckin()
        await calculateRelevProgress()
    }

    const filterFormsByDate = (form): boolean => {
        try {
            let filter = false

            const currentDate = new Date()

            const questions = form.contents
            const formStartEjecution = form.start_ejecution ?? null
            const formEndEjecution = form.end_ejecution ?? null

            if (formStartEjecution && formEndEjecution) {
                const startEjecution = new Date(formStartEjecution)
                const endEjecution = new Date(formEndEjecution)
                return startEjecution <= currentDate && endEjecution >= currentDate
            }

            if (questions && questions.length > 0) {
                for (const quest of questions) {
                    const questStartEjecution = quest.start_ejecution ?? null // start_ejecution
                    const questEndEjecution = quest.end_ejecution ?? null // end_ejecution

                    if (questStartEjecution && questEndEjecution) {
                        const startEjecution = new Date(quest.start_ejecution)
                        const endEjecution = new Date(quest.end_ejecution)

                        const boolean = startEjecution <= currentDate && endEjecution >= currentDate

                        if (boolean) {
                            filter = boolean
                            break
                        }
                    }
                }
            }

            return filter
        } catch (error) {
            console.error('Error en filterFormsByDate:', error)
            const dataCapture = {
                log: error.message,
                date: new Date().toISOString(),
                end: 'filterFormsByDate',
                additional: JSON.stringify({
                    store_id: storeID,
                    schedule_id: scheduleID,
                    forms: forms,
                    form_id: form._id,
                    formsContext: formsContext,
                }),
            }
            captureAndSaveDataError(dataCapture)

            return false
        }
    }

    /**
     *
     * @param arrayFormsPos data.single.forms_pos
     */
    const saveFormsHeladeras = async (arrayFormsPos) => {
        console.log('121 -- ')

        const forms_ids_heladeras = []

        const forms_refrigerators = [] // los forms dentro de forms padres
        const form_refrigerators_main = [] // forms padres

        if (arrayFormsPos && arrayFormsPos.length > 0) {
            for (const form of arrayFormsPos) {
                const form_id_father = form._id
                await schedulesServices.addForm(form, false, true)
                forms_ids_heladeras.push(form._id) // pusheo
                if (form.contents && form.contents.length > 0) {
                    for (const content of form.contents) {
                        // content.active = true // me viene del servicio ya
                        if (
                            content.secondary_actions &&
                            content.secondary_actions.length > 0 &&
                            content.secondary_actions.some((action) => action.form && action.form.length > 0)
                        ) {
                            for (const action of content.secondary_actions) {
                                if (action && action.form && action.form.length > 0) {
                                    let create_refrigerator = false
                                    if (content.input_type && content.input_type && content.input_type.type === 16) {
                                        create_refrigerator = true
                                    }
                                    await schedulesServices.addForm(action.form[0], false, true, create_refrigerator, form_id_father)
                                    let form = action.form[0]
                                    form.form_id_father = form_id_father
                                    form.question_id = content._id
                                    forms_refrigerators.push(form)
                                    forms_ids_heladeras.push(action.form[0]['_id'])
                                }
                            }
                        }
                    }

                    form_refrigerators_main.push(form)
                }
            }
        }

        if (forms_ids_heladeras && forms_ids_heladeras.length > 0) {
            for (const form_id of forms) {
                await schedulesServices
                    .getForm(form_id)
                    .then(async (get_form) => {
                        const questions = get_form.contents.map((question) => {
                            return {
                                _id: question._id,
                                title: question.title,
                                ponderar: question.questionScore && question.questionScore > 0, //[7, 8, 14, 18].includes(question.input_type.type),
                                questionScore: question.questionScore,
                                input_type: question.input_type,
                                secondary_actions: question.secondary_actions,
                                mandatory: question.mandatory,
                                score: question.score,
                            }
                        })

                        const form_save = {
                            schedule_id: scheduleID,
                            form_id: form_id,
                            store_id: storeID,
                            repeat: get_form.repeat,
                            questions: JSON.stringify(questions) ?? '[]',
                            progress: get_form.progress,
                            totalScore: get_form.totalScore,
                            name_form: get_form.name_form,
                            heladera: get_form.heladera,
                            create_refrigerator: get_form.create_refrigerator,
                            type_form: get_form.type_form,
                            form_id_father: get_form.form_id_father,
                        }

                        const saveFormResponse = await schedulesServices.saveFormAnswers(form_save)
                    })
                    .catch((error) => console.error(`290:   getForm: ${form_id} - `, error))
            }
        }

        set_forms_refrigerators(forms_refrigerators)
        set_form_refrigerators_main(form_refrigerators_main)
    }

    const agregateUsersFormDropdown = async (arrayFormUsers: SecondaryActionFormUsers[]) => {
        try {
            if (!arrayFormUsers || arrayFormUsers.length === 0) {
                console.log('no hay usuarios en el formulario')
                return
            }
            await schedulesServices.updateFormsSecondaryActionUsersDropdown(arrayFormUsers, storeID)
            await fetchDataLocalNew()
        } catch (error) {
            console.error('Error en agregateUsersFormDropdown:', error)
        }
    }

    const validateStatusCheckOut = () => {
        setStatusCheckin(CHECKOUT_REALIZADO)
    }

    const validateStatusCheckin = async () => {
        try {
            let status = null
            //ahora en tomo el status de checkin y checkout de schedules_advance
            await schedulesServices
                .getStoreScheduleAdvances(scheduleID, storeID)
                .then((response) => {
                    if (response) {
                        //tiene avance

                        //valido fechaa
                        let fecha_hoy = new Date()
                        let offset = fecha_hoy.getTimezoneOffset()
                        // Convertir la fecha y hora actual de UTC a la zona horaria local del usuario
                        fecha_hoy.setMinutes(fecha_hoy.getMinutes() - offset)
                        let fecha_hoy_str = fecha_hoy.toISOString().split('T')[0]

                        //console.log('Fecha de hoy (solo fecha):', fecha_hoy_str, new Date(fecha_hoy_str))

                        if (
                            new Date(response.date_init) < new Date(fecha_hoy_str) &&
                            response.status != CampaignStatus.STATUS_FORM_PENDING_MODERATION &&
                            response.status != CampaignStatus.STATUS_MODERATION_APPROVED
                        ) {
                            // console.log('-----------fecha de hoyyy222222 ~ fecha_hoy:', fecha_hoy)
                            response.status = null
                        }
                        // console.log('457 --- -----------response222222 ~ response:', response.status)
                        switch (response.status) {
                            case CampaignStatus.STATUS_FORM_IN_PROGRESS:
                                setStatusCheckin(CHECKIN_REALIZADO)
                                setCurrentCheckin(response?.checkin_id)
                                schedulesServices.get_checkin(storeID, scheduleID).then((checkin) => {
                                    if (checkin) {
                                        const index = checkin.length - 1
                                        setCheckinIDLocal(checkin[index]._id)
                                        setCheckinID(checkin[index].checkin_id)
                                    } else {
                                        if (response?.checkin_id) {
                                            setCheckinID(response?.checkin_id)
                                        }
                                    }
                                })
                                status = CHECKIN_REALIZADO
                                break
                            case CampaignStatus.STATUS_MODERATION_APPROVED:
                            case CampaignStatus.STATUS_FORM_PENDING_SYNC:
                            case CampaignStatus.STATUS_FORM_APPROVED:
                            case CampaignStatus.STATUS_FORM_PENDING_MODERATION:
                                setStatusCheckin(CHECKOUT_REALIZADO)
                                status = CHECKOUT_REALIZADO
                                break
                            case CampaignStatus.STATUS_FORM_REFUSED:
                                status = CampaignStatus.STATUS_FORM_REFUSED
                                break
                            default:
                                break
                        }
                    } else {
                        console.log('NO HAY AVANCESSS EN validateStatusCheckin')

                        //no hizo nada
                    }
                })
                .catch((error) => console.error(error))
            return status
        } catch (error) {
            console.error('validateStatusCheckin => ', error)
            throw new Error(error)
        }
    }

    const setDataPFA = async () => {
        try {
            const forms = await schedulesServices.getPerfectStoreRelationByStore(storeID)

            if (forms && forms.length > 0) {
                setIsLoadingPerfectStore(false)
            }
            return forms
        } catch (error) {
            console.error('Error en setDataPFA:', error)
        }
    }

    const setData = async (data: StoreDetailModel) => {
        let newDistance = getDistanceWithTextCal(distance)
        setStoreInfo({
            ...data?.data_sheet,
            distance: newDistance,
        })
        if (data && data.data_sheet && data.data_sheet.kpis_indicators && data.data_sheet.kpis_indicators.length > 0) {
            setKpis(data.data_sheet.kpis_indicators)
            await schedulesServices.updateStoreKPIS(storeID, data.data_sheet.kpis_indicators)
        }
        //console.log('550 --- 🚀 ~ setData ~ data?.perfect_store', data)

        //* -- Perfect Store offline ?
        let formsPerfectStoreData = []
        let formsPerfectStoreLocal = await setDataPFA()

        // console.log(
        //     '556 - 🚀 ~ setData ~ formsPerfectStoreLocal:',
        //     formsPerfectStoreLocal.length,
        //     formsPerfectStoreLocal.map((item) => item._id),
        // )
        let formsPerfectStoreOnline = data?.perfect_store ?? []
        // console.log(
        //     '558 - 🚀 ~ setData ~ formsPerfectStoreOnline:',
        //     formsPerfectStoreOnline.length,
        //     formsPerfectStoreOnline.map((item) => item._id),
        // )

        if (formsPerfectStoreOnline && formsPerfectStoreOnline.length > 0) {
            // comparar ids en ambos
            // console.log('comparar ids en ambos')
            if (formsPerfectStoreLocal && formsPerfectStoreLocal.length > 0) {
                // console.log('563 -- tengo local')
                formsPerfectStoreData = formsPerfectStoreLocal
                let hasUpdatePerfecStore = false
                // tengo local entonces comparo
                // tengo que comparar entre ids de ambos

                for (const formOnline of formsPerfectStoreOnline) {
                    const formLocal = formsPerfectStoreLocal.find((form) => form._id.toString() === formOnline._id.toString())
                    if (!formLocal) {
                        // no esta en local, lo agrego
                        formsPerfectStoreData.push(formOnline)
                        hasUpdatePerfecStore = true
                    }
                }

                if (hasUpdatePerfecStore) {
                    setIsLoadingPerfectStore(true)
                }
            } else {
                console.log('583 --- no tengo local, utilizo online')
                // no tengo local entonces utilizo online
                formsPerfectStoreData = formsPerfectStoreOnline
                setIsLoadingPerfectStore(true)
            }
        } else {
            // no tengo online, entonces utilizo local
            console.log('no tengo online, entonces utilizo local')
            formsPerfectStoreData = formsPerfectStoreLocal ?? []
        }

        if ((!formsPerfectStoreLocal || formsPerfectStoreLocal.length == 0) && (!formsPerfectStoreOnline || formsPerfectStoreOnline.length == 0)) {
            setIsLoadingPerfectStore(true)
        }

        if (formsPerfectStoreData && formsPerfectStoreData.length > 0 && data && data?.perfect_store_fa) {
            formsPerfectStoreData = [...formsPerfectStoreData, ...data?.perfect_store_fa]
        }

        const formsPerfectStoredataFilter = filterObjetives(formsPerfectStoreData)

    setPFA(formsPerfectStoredataFilter.sort((a, b) => (a.index ?? 0) - (b.index ?? 0)))

        setVouchers(data.vouchers ?? [])
        const updatedForms = data?.forms?.map((form) => {
            const updatedContents = form?.contents?.map((content) => {
                if (content.status === 3) {
                    return {
                        ...content,
                        hideQuestion: true,
                    }
                }
                return content
            })
            return {
                ...form,
                contents: updatedContents,
            }
        })
        // setForms((prevStore) => [...prevStore, ...updatedForms])
        if (updatedForms && updatedForms.length > 0) {
            setFormsContext((prevStore) => [...prevStore, ...updatedForms])
        }

        //setForms(updatedForms ?? [])
    }

    const filterObjetives = (formsPerfectStoredata) => {
        const currentDate = new Date()

        let filter_forms = formsPerfectStoredata.filter((form) => {
            if (!form.start_ejecution && !form.end_ejecution) return true

            const startEjecution = new Date(form.start_ejecution)
            const endEjecution = new Date(form.end_ejecution)
            return startEjecution <= currentDate && endEjecution >= currentDate
        })

        return filter_forms
    }

    const navigateToPF = (index: number) => {
        console.log('127 -- ')

        navigation.navigate('PerfectStoreView', { perfectStore: perfectStoreArray, selectedIndex: index, storeInfo: store })
    }

    const navigateToForms = useCallback(
        async (indexOrIdOrName: number | string, nameFormFallback?: string) => {
            let finalIndex: number = -1
            
            if (typeof indexOrIdOrName === 'string') {
                // Intento 1: Buscar por _id
                finalIndex = formsContext.findIndex((form) => form._id === indexOrIdOrName)
                
                if (finalIndex !== -1) {
                    console.log('navigateToForms -- Found form by _id at INDEX:', finalIndex)
                } else {
                    // Intento 2: Buscar por name_form (puede venir como parámetro o usar el mismo string)
                    const searchName = nameFormFallback || indexOrIdOrName
                    finalIndex = formsContext.findIndex((form) => form.name_form === searchName)
                    
                    if (finalIndex !== -1) {
                        console.log('navigateToForms -- Found form by name_form at INDEX:', finalIndex)
                    } else {
                        console.error('navigateToForms -- Form not found with _id or name_form:', indexOrIdOrName)
                        return
                    }
                }
            } else {
                // Si recibimos un índice numérico, usarlo directamente (fallback final)
                finalIndex = indexOrIdOrName
                console.log('navigateToForms -- Using provided INDEX:', finalIndex)
            }
            
            if (isValidMongoId(checkInID)) {
                navigation.navigate('ExecutionView', {
                    forms: formsContext,
                    selectedIndex: finalIndex,
                    schedule_id: scheduleID,
                    store_id: storeID,
                    storeInfo: store,
                    checkin_id: checkInID,
                    status_store: status_store,
                    statusCheckin: statusCheckin,
                })
            } else {
                const hasConnection = await validateConnectionNetwork()
                if (hasConnection) {
                    const checkin = await schedulesServices.get_checkin(storeID, scheduleID)
                    let checkin_id = checkin && checkin.length > 0 ? checkin[checkin.length - 1].checkin_id : null

                    if (isValidMongoId(checkin_id)) {
                        navigation.navigate('ExecutionView', {
                            forms: formsContext,
                            selectedIndex: finalIndex,
                            schedule_id: scheduleID,
                            store_id: storeID,
                            storeInfo: store,
                            checkin_id: checkin_id,
                            status_store: status_store,
                            statusCheckin: statusCheckin,
                        })
                    }
                } else {
                    navigation.navigate('ExecutionView', {
                        forms: formsContext,
                        selectedIndex: finalIndex,
                        schedule_id: scheduleID,
                        store_id: storeID,
                        storeInfo: store,
                        checkin_id: checkInID,
                        status_store: status_store,
                        statusCheckin: statusCheckin,
                    })
                }
            }
            const form_id = formsContext[finalIndex]?._id ? formsContext[finalIndex]._id : ''
            TrackingServices.addTracking(form_id, TRACKINGS_TYPES.NAVIGATE_FORM_STORE, 'ExecutionView')
        },
        [navigation, formsContext, scheduleID, storeID, store, checkInID, status_store, statusCheckin],
    )

    const saveItemSteps = async (item) => {
        console.log('128 -- ')

        try {
            setStepsDistri(item)
        } catch (error) {
            console.error('🚀 ~ saveItemSteps ~ error:', error)
        }
    }

    const saveSteps = async (dataSteps) => {
        console.log('129 -- ')

        try {
            console.log('envio steps y llamo al checkin....', dataSteps.length)
            await checkIn(true, dataSteps)
            closeBottomSheet(true)
            setStatusSteps(CHECKIN_REALIZADO)
        } catch (error) {
            console.error('🚀 ~ saveSteps ~ error:', error)
        }
    }

    const validate_steps = async (type, number = null) => {
        console.log('130 -- ')

        try {
            if (steps.length > 0) {
                let steps_checkin = steps.filter((item) => item.type == type)
                //console.log(type, '🚀 ~ constvalidate_steps= ~ steps_checkin:', steps_checkin)
                if (steps_checkin.length > 0) {
                    switch (type) {
                        case CONSTANTS_TYPES_STEPS.CHECKIN_STEPS_DISTRIBUTOR:
                            try {
                                //await schedulesServices.get_checkin_steps(storeID, scheduleID).then((response) => {
                                // if (!response) {
                                let new_steps: { label: string; type: any }[] = steps_checkin[0]['forms'].map((item: any) => {
                                    return {
                                        label: item?.label as string,
                                        type: item?.type,
                                    }
                                })
                                //  alert('tenes steps pendientes')
                                openBottomSheet(
                                    <FormSteps
                                        fields={new_steps}
                                        store_id={storeID}
                                        schedule_id={scheduleID}
                                        closeBottomSheet={closeBottomSheet}
                                        saveSteps={saveSteps}
                                        saveItemSteps={saveItemSteps}
                                        option={type}
                                    />,
                                    null,
                                    false, //false para que no se pueda cerrar el modal
                                )
                                return {
                                    status: 0,
                                    step: '',
                                    message: 'tiene que haer el form de steps',
                                }
                                // } else {
                                //     setStatusSteps(CHECKIN_REALIZADO)
                                //     //   alert('ya realizaste los steps')
                                //     return {
                                //         status: 1,
                                //         step: '',
                                //         message: false,
                                //     }
                                // }
                                // })
                            } catch (error) {
                                console.error(error)
                                return {
                                    status: -1,
                                    step: '',
                                    message: false,
                                }
                            }
                        case CONSTANTS_TYPES_STEPS.CHECKIN_STEPS:
                            try {
                                await schedulesServices.get_checkin_steps(storeID, scheduleID).then((response) => {
                                    if (!response) {
                                        let new_steps: { label: string; type: any }[] = steps_checkin.map((item: any) => {
                                            return {
                                                label: item?.label as string,
                                                type: item?.type_action,
                                            }
                                        })
                                        //  alert('tenes steps pendientes')
                                        const snapPoints = ['60%']
                                        openBottomSheet(
                                            <FormSteps
                                                fields={new_steps}
                                                store_id={storeID}
                                                schedule_id={scheduleID}
                                                closeBottomSheet={closeBottomSheet}
                                                saveSteps={saveSteps}
                                                saveItemSteps={saveItemSteps}
                                                option={type}
                                            />,
                                            snapPoints,
                                        )
                                    } else {
                                        setStatusSteps(CHECKIN_REALIZADO)
                                        //   alert('ya realizaste los steps')
                                        return {
                                            status: 1,
                                            step: '',
                                            message: false,
                                        }
                                    }
                                })
                            } catch (error) {
                                console.error(error)
                                return {
                                    status: -1,
                                    step: '',
                                    message: false,
                                }
                            }
                            break
                        case CONSTANTS_TYPES_STEPS.STOPS_BY:
                            if (number) {
                                const number_checkin = number + 1
                                let filter_step = steps_checkin.find((item) => item.checkins == number_checkin)

                                if (steps_checkin.length > 0 && filter_step) {
                                    // alert(
                                    //     `¡Felicitaciones! Has alcanzado tu check-in número ${number}. No es necesario que completes el formulario adicional.`,
                                    // )
                                    //busco el name del form
                                    let nameform = await schedulesServices.getFormName(filter_step['forms'][0]['_id'])
                                    return {
                                        status: 1,
                                        step_number: number,
                                        step: filter_step,
                                        message:
                                            languageFile.visiting_your_store + `${number_checkin}.` + languageFile.you_can_check_out + `${nameform}.`,
                                    }
                                } else {
                                    return {
                                        status: -1,
                                        step: {},
                                        message: false,
                                    }
                                }
                            } else {
                                return {
                                    status: -1,
                                    step: {},
                                    message: false,
                                }
                            }
                        case CONSTANTS_TYPES_STEPS.OBJECTIVE_COMPLETE:
                            //verifico si cumpli el objetivo
                            if (number) {
                                //busco si la agenda tiene additional objetives o tomo el de campaña
                                let filter_step_objetive = steps.find((item) => item.type == CONSTANTS_TYPES_STEPS.OBJECTIVES)
                                await schedulesServices.get_schedule(scheduleID).then((schedule) => {
                                    if (schedule.additional && schedule.additional.objective && schedule.additional.objective.length > 0) {
                                        //ARMO EL STEP
                                        filter_step_objetive = {
                                            checkins:
                                                parseInt(schedule.additional.objective[0]['objetive']) +
                                                (schedule.additional.stop_by ? schedule.additional.stop_by.length : 0),
                                            forms: [
                                                {
                                                    _id: schedule['form_finish'] ? schedule['form_finish']['_id'] : null,
                                                    status: 2,
                                                },
                                            ],
                                        }
                                    }
                                })

                                // console.log('🚀 ~ constvalidate_steps= ~ filter_step_objetive:', filter_step_objetive)
                                if (filter_step_objetive && number >= filter_step_objetive.checkins) {
                                    return {
                                        status: 1,
                                        step_number: number,
                                        step: steps_checkin[0],
                                        message: languageFile.you_met_the_goal,
                                    }
                                } else {
                                    return {
                                        status: -1,
                                        step: {},
                                        message: false,
                                    }
                                }
                            } else {
                                return {
                                    status: -1,
                                    step: {},
                                    message: false,
                                }
                            }

                        default:
                            return {
                                status: -1,
                                step: '',
                                message: false,
                            }
                    }
                } else {
                    return {
                        status: 1,
                        step: '',
                        message: false,
                    }
                }
            } else {
                setStatusSteps(CHECKIN_REALIZADO)
                return {
                    status: -1,
                    step: '',
                    message: false,
                }
            }
        } catch (error) {
            console.error('954 - validate_steps ~ error:', error)
            throw new Error(error)
        }
    }

    const calculateRelevProgress = async () => {
        if (forms_relevant.length === 0) {
            setProgressRelev(0)
            return
        }

        const completedForms = formsContext.filter(
            (form) => form?.status === FORM_SCHEDULE_STATUS.COMPLETED && forms_relevant.some((relevant) => relevant._id === form._id),
        )
        const progress = (completedForms.length / forms_relevant.length) * 100

        // Redondear hacia abajo para eliminar los decimales
        const roundedProgress = Math.floor(progress)

        setProgressRelev(roundedProgress >= 100 ? 100 : roundedProgress)
    }

    const validate_forms_relevant = async () => {
        let response = { status: 1, message: 'todo ok', form_id: null }
        if (forms_relevant && forms_relevant.length > 0) {
            const count = await schedulesServices.get_total_checkin_count(scheduleID)
            let verify_step = await validate_steps(CONSTANTS_TYPES_STEPS.OBJECTIVE_COMPLETE, count)
            if (!verify_step || verify_step.status != 1) {
                verify_step = await validate_steps(CONSTANTS_TYPES_STEPS.STOPS_BY, count)
            }

            let filteredForms = forms_relevant

            if (verify_step.status == 1 && verify_step['step'] && verify_step['step']['forms'].length > 0) {
                filteredForms = forms_relevant.filter((elem) => elem._id !== verify_step['step']['forms'][0]['_id'])
            }
            // console.log('1051 - 🚀 ~ constvalidate_forms_relevant= ~ filteredForms:', filteredForms, verify_step)

            let groupedForms = filteredForms.reduce((acc, form) => {
                // Si tiene activity_id, agrupamos por esa clave
                if (form.activity_id) {
                    // Verificamos si ya existe un grupo para ese activity_id
                    const group = acc.find((item) => item.activity_id === form.activity_id)
                    if (group) {
                        // Si existe el grupo, agregamos el _id del formulario al array 'forms'
                        group.forms.push(form._id)
                    } else {
                        // Si no existe el grupo, creamos uno nuevo con el _id del formulario
                        acc.push({
                            _id: form._id,
                            activity_id: form.activity_id,
                            forms: [form._id],
                            hex_color: form.hex_color,
                            name: form.name,
                        })
                    }
                } else {
                    // Si no tiene activity_id, simplemente lo agregamos sin modificaciones
                    acc.push({
                        _id: form._id,
                        hex_color: form.hex_color,
                        name: form.name,
                    })
                }

                return acc
            }, [])

            groupedForms = groupedForms.filter((form) => {
                if (!form || !form._id) return false
                return formsContext?.some((formContext) => formContext?._id.toString() === form._id.toString())
            })

            groupedForms = formsContext
                .map((formCont) => groupedForms.find((form) => form?._id?.toString() === formCont._id?.toString()))
                .filter(Boolean)

            for (let i = 0; i < groupedForms.length; i++) {
                const form = groupedForms[i]

                // Verificamos si tiene la propiedad 'forms' (es decir, si tiene formularios asociados con el mismo activity_id)
                if (form.forms && form.forms.length > 0) {
                    let isCompleteGroup = false

                    // Recorremos cada formulario en la propiedad 'forms' y verificamos si al menos uno está completo
                    for (let j = 0; j < form.forms.length; j++) {
                        const formId = form.forms[j]
                        const isComplete = await schedulesServices.isFormComplete(
                            formId,
                            storeID,
                            scheduleID,
                            FORM_SCHEDULE_STATUS.COMPLETED,
                            FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                            FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION,
                        )

                        if (isComplete) {
                            isCompleteGroup = true
                            break // Si al menos uno está completo, no es necesario seguir buscando
                        }
                    }

                    // Si el grupo completo no está hecho, mostramos el mensaje de que falta completar el formulario
                    if (!isCompleteGroup) {
                        const name_form = await schedulesServices.getFormName(form._id)
                        response = {
                            status: 0,
                            message: languageFile.you_must_complete_the_survey + `${name_form}`,
                            form_id: form._id,
                        }
                        break // Salimos del ciclo porque no se puede continuar hasta completar el formulario
                    }
                } else {
                    // Si no tiene 'forms', verificamos el formulario individual
                    let isComplete = await schedulesServices.isFormComplete(
                        form._id,
                        storeID,
                        scheduleID,
                        FORM_SCHEDULE_STATUS.COMPLETED,
                        FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                        FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION,
                    )

                    // console.log('789 --- isComplete: ', isComplete, form._id, storeID, scheduleID)

                    // Si no está completo, validamos el estado del formulario en el contexto
                    if (!isComplete) {
                        const formIndex = formsContext.findIndex((formulario) => formulario._id == form._id)
                        // console.log('🚀 ~ constvalidate_forms_relevant= ~ formIndex:', formIndex)
                        if (formIndex !== -1) {
                            const STATUS_VALIDATES = [
                                FORM_SCHEDULE_STATUS.COMPLETED,
                                FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                                FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION,
                            ]

                            if (STATUS_VALIDATES.includes(formsContext[formIndex].status)) {
                                isComplete = true
                            }
                        }
                    }

                    // Si no está completo, mostramos el mensaje de que falta completar el formulario
                    if (!isComplete) {
                        let name_form = await schedulesServices.getFormName(form._id)
                        response = {
                            status: 0,
                            message: languageFile.you_must_complete_the_survey + `${name_form}`,
                            form_id: form._id,
                        }
                        break // Salimos del ciclo porque no se puede continuar hasta completar el formulario
                    }
                }
            }
        }

        return response
    }

    const checkIn = async (cont = false, itemsSteps = []) => {
        console.log(
            'form ids fqa => ',
            formsContext.map((form) => form.form_id_fqa),
        )
        const formsIdsFqa = formsContext.map((form) => form.form_id_fqa)
        // fecha_hoy.setHours(0, 0, 0, 0)
        setLoadingCheckin(true)

        // verificar si estoy entre la distancia que me llega en el store
        console.log('------------------> ~ checkIn -------------------:', cont, itemsSteps.length)

        if (checkoutInProcess) {
            return
        }
        try {
            setCheckoutInProcess(true)
            let { status, store, schedule_advances } = await schedulesServices.validateCheckins(scheduleID)

            console.log('🚀 ~ checkIn ~ status:', status, schedule_advances)
            //valido fechaa
            let fecha_hoy = new Date()
            let offset = fecha_hoy.getTimezoneOffset()
            // Convertir la fecha y hora actual de UTC a la zona horaria local del usuario
            fecha_hoy.setMinutes(fecha_hoy.getMinutes() - offset)

            let fecha_hoy_str = fecha_hoy.toISOString().split('T')[0]

            console.log(status, '-----------fecha de hoyyy ~ fecha_hoy:', fecha_hoy_str, schedule_advances)

            if (!status && schedule_advances && schedule_advances.date_init < fecha_hoy_str) {
                console.log('-----------esta vencidoo~ fecha_hoy:', fecha_hoy_str, schedule_advances.date_init)
                status = true
            }

            // console.log('🚀 ~ checkIn ~ status:', status)

            if (!status) {
                let title = languageFile.checkin_blocked
                let desc = languageFile.close_the_open_checkin
                let button = languageFile.accept

                if (store && store.name && store.code) {
                    desc = languageFile.close_the_checkin_opened_in + `${store.name}, ${store.code}`
                }

                return openBottomSheet(
                    <BottomSheetAlert
                        image={require('../../../assets/stores/checkinLocked.png')}
                        title={title}
                        desc={desc}
                        button={button}
                        closeBottomSheet={closeBottomSheet}
                    />,
                    ['50%'],
                )
            }

            const cordUser = {
                lat: userLat,
                lng: userLng,
                last_update_coords: lastUpdateCoorsUser,
            }

            const canValidateDistance = validateUpdateCoordsTime(lastUpdateCoorsUser)

            const isValidDistanceCheckin = await schedulesServices.isValidDistanceCheckin(storeID, cordUser)

            if (!isValidDistanceCheckin && canValidateDistance) {
                //* se comenta ya que no funcionan bien los modales en android
                // let title = languageFile.checkin_out_of_range
                // let desc = languageFile.more_meters_from_the_store
                // let button = languageFile.accept

                // return openBottomSheet(
                //     <BottomSheetAlert
                //         image={require('../../../assets/stores/outOfRange.png')}
                //         title={title}
                //         desc={desc}
                //         button={button}
                //         closeBottomSheet={closeBottomSheet}
                //     />,
                //     ['40%'],
                // )
                // return alert('Fuera de rango para realizar checkin')
                let distanceValue = 50
                const maximumDistance = await schedulesServices.getStoreMaxDistance(storeID) // distancia por defecto de 50 mts
                if (expoConfig.slug === 'beiersdorf-wts') {
                    if (maximumDistance && maximumDistance > 0) {
                        distanceValue = maximumDistance
                    }
                }

                setValidateCheckin({
                    isPosibleCheckin: true,
                    messageValidateCheckin: `🚫 Estás fuera de los ${distanceValue} mts.`,
                })

                return
            }

            const validate = await validate_steps(CONSTANTS_TYPES_STEPS.CHECKIN_STEPS)

            // const validate_step_distri = await validate_steps(CONSTANTS_TYPES_STEPS.CHECKIN_STEPS_DISTRIBUTOR, null)
            // console.log(' validate_step_distri:', validate_step_distri, cont)
            // if (validate_step_distri && validate_step_distri.status == 0 && itemsSteps.length == 0) {
            //     //status 0 es que tiene ese step y lo tiene que realizar
            //     console.log('====================================')
            //     console.log('hay que hacer el form de stepss,  itemsSteps.length', itemsSteps.length)
            //     console.log('====================================')
            //     return
            // }
            //throw 'para'

            if (statusSteps === CHECKIN_REALIZADO || cont || (validate && validate.status == 1)) {
                let dif_utc = -new Date().getTimezoneOffset() / 60

                let checkinID = Date.now().toString() // checkinID temporal

                let status_send = 0
                let objectives = []
                //agrego o inc los contadores de forms

                let schedule = await schedulesServices.get_schedule(scheduleID)

                // console.log('🚀 ~ checkIn ~ schedule:', schedule.additional)
                if (
                    schedule &&
                    schedule.additional &&
                    schedule.additional.objective &&
                    schedule.additional.objective.length > 0 &&
                    schedule.additional.objective.some((item) => item.type == CONSTANTS_TYPES_STEPS.OBJECTIVES_BY_FORMS_GROUP)
                ) {
                    let steps_group_forms = schedule.additional.objective.find((item) => item.type == CONSTANTS_TYPES_STEPS.OBJECTIVES_BY_FORMS_GROUP)
                    if (steps_group_forms && steps_group_forms.form.length > 0 && steps_group_forms.name_required.length > 0) {
                        let get_names_forms = await schedulesServices.get_name_forms(steps_group_forms.name_required, steps_group_forms.form, forms)
                        objectives = get_names_forms
                    }
                }

                const { existsInDB, _id_mongoDB } = await schedulesServices.getExistsInDB(storeID)

                const hasConnection = await validateConnectionNetwork()

                if (hasConnection && existsInDB) {
                    const session = await fetchAuthSession()
                    const authToken = session.tokens?.accessToken?.toString() || ""
                    const data = {
                        authToken: authToken,
                        body: {
                            store_id: _id_mongoDB ? _id_mongoDB : storeID,
                            lat: String(userLat),
                            lng: String(userLng),
                            date_init: new Date().toISOString(),
                            dif_utc: dif_utc.toString(),
                            schedule_id: scheduleID,
                            objectives: objectives,
                            steps_distributor: itemsSteps,
                        },
                    }

                    // console.log('1251 - 🚀 ~ checkIn ~ data:', data, itemsSteps.length)
                    const res = await request_checkin(data)

                    //console.log('🚀 ~ checkIn ~ res:', res)
                    if (res && res.status) {
                        checkinID = res.response?.single?.checkin_status?._id
                        console.log('🚀 ~ checkIn ~ response:', res.response.single)
                        status_send = 1

                        console.log('formsIdsFqa ====> ', formsIdsFqa)
                        console.log('checkinID ====> ', checkinID)

                        await schedulesServices.updateKeyCheckinFqa(checkinID, formsIdsFqa)

                        if (res.response?.single?.advance) {
                            await addOrUpdateAdvanceSchedule(res.response?.single?.advance)
                        }
                    }
                    //checkinID = (res && res?.single?.checkin_status?._id) ?? ''
                    // console.log("872 ---- 🚀 ~ checkIn ~ checkinID:", checkinID)
                    setCurrentCheckin(checkInID)
                    setCheckinID(checkinID)
                }

                const data_local = {
                    date: new Date().toISOString(),
                    store_id: existsInDB ? _id_mongoDB : storeID,
                    lat_checkin: String(userLat),
                    lng_checkin: String(userLng),
                    schedule_id: scheduleID,
                    date_init: new Date().toISOString(),
                    dif_utc: dif_utc.toString(),
                    status: status_send ? FORM_SCHEDULE_STATUS.COMPLETED : FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                    objectives: objectives,
                    steps_distributor: itemsSteps,
                    formsIdsFqa: formsIdsFqa,
                }

                const checkin = await schedulesServices.add_checkin(data_local, checkinID)

                if (checkin && checkin.checkin_id) {
                    setCheckinID(checkin.checkin_id)
                }

                TrackingServices.addTracking(checkinID, TRACKINGS_TYPES.CHECKIN, 'StoreDetail')

                if (!status_send) {
                    await schedulesServices.upsertScheduleAdvanceLocal(
                        scheduleID,
                        storeID,
                        FORM_SCHEDULE_STATUS.IN_PROGRESS,
                        new Date().toISOString(),
                        [],
                        objectives,
                    )
                }
                //si hay algo en los steps los limpio
                clearStepsDistributor()
                setStatusCheckin(CHECKIN_REALIZADO)
                await schedulesServices.update_status_store(storeID, scheduleID, CampaignStatus.STATUS_FORM_IN_PROGRESS, new Date().toISOString())

                await updateStatusForms(FORM_SCHEDULE_STATUS.PENDING)

                // Actualiza campaign_status en el contexto global de la tienda
                updateStoreStatus(storeID, CampaignStatus.STATUS_FORM_IN_PROGRESS)

                await validateStatusCheckin()
                const count = await schedulesServices.get_total_checkin_count(scheduleID)

                let stop = await validate_steps(CONSTANTS_TYPES_STEPS.STOPS_BY, count)

                if (stop && stop?.status == 1 && stop.step) {
                    let title = languageFile.now_is_your_turn
                    let desc = stop?.message ?? ''
                    let button = languageFile.accept

                    openBottomSheet(
                        <BottomSheetAlert
                            image={require('../../../assets/stores/stepsStore.png')}
                            title={title}
                            desc={desc}
                            button={button}
                            closeBottomSheet={closeBottomSheet}
                        />,
                    )

                    // alert(stop?.message)
                }
            }
        } catch (error) {
            console.error('665 ------ checkIn: ', error)
        } finally {
            console.log('1382 --- finalizo checkin')
            setCheckoutInProcess(false)
            setLoadingCheckin(false)
        }
    }

    /**
     * @description valida si tengo formularios en progreso y pendientes antes de realizar checkout STATUS = 1 : NO TENGO PENDIENTES NI EN CURSOS, STATUS = 0 : TENGO PENDIENTES O EN CURSO
     */
    const validate_forms_in_progress_pending = () => {
        try {
            let status = 0
            let message = ''
            let form_id = ''
            const forms_in_progress = formsContext.filter((form) => form.status === FORM_SCHEDULE_STATUS.IN_PROGRESS)
            const forms_pending = formsContext.filter((form) => form.status === FORM_SCHEDULE_STATUS.PENDING)

            if (forms_in_progress && forms_in_progress.length > 0) {
                const nameForms = forms_in_progress.map((form) => form.name_form)
                if (nameForms && nameForms.length > 0) {
                    message = languageFile.surveys_in_progress + `${nameForms.join(', ')}`
                }
                form_id = forms_in_progress[0]['_id']
            } else {
                status = 1
            }

            return {
                status,
                title: languageFile.want_to_checkout,
                message,
                form_id,
            }
        } catch (error) {
            console.error('586 --- validate_forms_in_progress_pending: ')
        }
    }

    const validate_forms_schedule_objective = () => {
        try {
            let status = 0
            let message = ''
            let form_id = ''
            const forms_objectives = formsContext.filter(
                (form) =>
                    form.objective == 1 && form.status != FORM_SCHEDULE_STATUS.COMPLETED && form.status != FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
            )
            console.log('forms_objectives:', forms_objectives.length)

            if (forms_objectives && forms_objectives.length > 0) {
                const nameForms = forms_objectives.map((form) => form.name_form)
                if (nameForms && nameForms.length > 0) {
                    message =
                        'Hay formularios obligatorios sin responder: ' +
                        `${nameForms.join(', ')}` +
                        ', lo que significa que el objetivo no se sumará en la tienda.'
                }
                form_id = forms_objectives[0]['_id']
            } else {
                status = 1
            }

            return {
                status,
                title: 'hay formularios de Objetivos pendientes',
                message,
                form_id,
            }
        } catch (error) {
            console.error('🚀 ~ constvalidate_forms_schedule_objective= ~ error:', error)
        }
    }

    const get_names_forms_pendings = () => {
        try {
            let status = 0
            let message = ''
            let form_id = ''

            const forms_objectives = formsContext.filter(
                (form) =>
                    form.objective == 1 && form.status != FORM_SCHEDULE_STATUS.COMPLETED && form.status != FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
            )

            if (forms_objectives && forms_objectives.length > 0) {
                const nameForms = forms_objectives.map((form) => {
                    return {
                        form_name: form.name_form,
                        form_id: form._id,
                    }
                })

                if (nameForms && nameForms.length > 0) {
                    message = `⚠️ Obligatorio: ${nameForms[0]['form_name']}`
                    form_id = nameForms[0]['form_id']
                }
            } else {
                status = 1
            }

            return {
                status,
                message,
                form_id,
            }
        } catch (error) {
            console.error('🚀 ~ get_names_forms_pendings= ~ error:', error)
        }
    }

    const findFormsRealizedInStore = async () => {
        try {
            const { existsInDB, _id_mongoDB } = await schedulesServices.getExistsInDB(storeID)

            const forms = await schedulesServices.getFormsRealizedByStore(scheduleID, storeID, _id_mongoDB)

            let filterFormsPending = forms.filter((form) => form.status_send == FORM_SCHEDULE_STATUS.PENDING_CONNECTION)

            if (existsInDB && filterFormsPending.length > 0) {
                filterFormsPending = filterFormsPending.map((form) => {
                    return {
                        ...form,
                        store_id: _id_mongoDB,
                    }
                })
            }
            return filterFormsPending
        } catch (error) {
            console.error('Error en findFormsRealizedInStore:', error)
            return []
        }
    }

    const checkOut = async () => {
        if (checkoutInProcess) {
            return
        }
        const hasConnection = await validateConnectionNetwork()
        console.log('🚀 ~ checkOut ~ hasConnection:', hasConnection, checkInID, checkInIDLocal)

        let dataCheckinID = checkInID
        let dataCheckinIDLocal = checkInIDLocal

        if ((dataCheckinID == '' || dataCheckinID == null) && (dataCheckinIDLocal == '' || dataCheckinIDLocal == null)) {
            const dataCheckin = await schedulesServices.get_checkin(storeID, scheduleID)
            if (dataCheckin) {
                const index = dataCheckin.length - 1
                dataCheckinIDLocal = dataCheckin[index]._id
                dataCheckinID = dataCheckin[index].checkin_id
            } else {
                //alert(No se encontra el checkin.)
                alert(languageFile.no_checkin_found)
                return
            }

            //vuelvo a consultar el id checkin
        }
        setCheckoutInProcess(true)
        console.log('checkOut')
        let checkOutID = ''
        let status_store = CampaignStatus.STATUS_FORM_PENDING_SYNC
        let dif_utc = 0
        let status_send = 0
        let data_send_forms = await createDataFormsSend(storeID, scheduleID)
        const formsIdsRealized = data_send_forms.map((form) => form.activity_id)
        generateKpiForms(formsIdsRealized, storeID, scheduleID)

        // console.log('------data_send_forms------ => ', data_send_forms)
        try {
            dif_utc = -new Date().getTimezoneOffset() / 60

            const hasConnection = await validateConnectionNetwork()

            //verifico si tiene pbjetivos y si los cumplio
            //const get_objective_status = await schedulesServices.findAndUpdateStatusProgres(scheduleID, storeID)
            //console.log('🚀 ~ checkOut ~ get_objective_status:', get_objective_status)

            const { existsInDB, _id_mongoDB } = await schedulesServices.getExistsInDB(storeID)
            if (hasConnection && checkInID && existsInDB) {
                const session = await fetchAuthSession()
                const authToken = session.tokens?.accessToken?.toString() || ""

                dataCheckinID = await getCheckinId(dataCheckinID)
                console.log('new dataCheckinID => ', dataCheckinID)
                // console.log('dadata_send_forms => ', data_send_forms)

                if (isValidMongoId(dataCheckinID)) {
                    const data = {
                        authToken: authToken,
                        body: {
                            store_id: _id_mongoDB ? _id_mongoDB : storeID,
                            id_check_in: dataCheckinID,
                            lat: String(userLat),
                            lng: String(userLng),
                            date_finish: new Date().toISOString(),
                            dif_utc: dif_utc.toString(),
                            schedule_id: scheduleID,
                            forms_view: data_send_forms ? data_send_forms : [],
                        },
                    }

                    const res = await request_checkout(data)

                    if (res && res.status) {
                        status_send = res.status
                        // console.log('status_send => ', status_send)
                        checkOutID = res?.response.single?.checkin_status?._id ?? ''
                        status_store = res?.response.single?.status_store ?? CampaignStatus.STATUS_FORM_APPROVED
                    }
                }
            }

            //* envio de forms
            // try {
            //     sendFormsRealizedStore()
            // } catch (error) {
            //     console.error('Error en sendFormsRealizedStore:', error)
            // }
            // // console.log('🚀 ~ checkoutID ~ data_local:', data_local)
        } catch (error) {
            console.error(error)
        } finally {
            try {
                const { existsInDB, _id_mongoDB } = await schedulesServices.getExistsInDB(storeID)

                const newStoreId = existsInDB ? _id_mongoDB : storeID

                const data_local = {
                    date: new Date().toISOString(),
                    store_id: newStoreId,
                    lat_checkout: String(userLat),
                    lng_checkout: String(userLng),
                    schedule_id: scheduleID,
                    date_finish: new Date().toISOString(),
                    dif_utc: dif_utc.toString(),
                    checkin_id: dataCheckinID,
                    checkin_id_local: dataCheckinIDLocal ? dataCheckinIDLocal.toString() : null,
                    status: status_send ? FORM_SCHEDULE_STATUS.COMPLETED : FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                    forms_view: data_send_forms ? JSON.stringify(data_send_forms) : [],
                }
                await schedulesServices.add_checkout(data_local, checkOutID).then((checkout) => {
                    //  console.log('checkoutcheckoutcheckoutcheckoutcheckoutcheckout', checkout)
                })
                setStatusCheckin(CHECKOUT_REALIZADO)

                await schedulesServices.update_status_store(newStoreId, scheduleID, status_store, new Date().toISOString()).then((update) => {
                    // console.log('updateupdateupdateupdateupdateupdateupdate checkout', update)
                })

                await schedulesServices.updateStatusCheckoutFormsQuestionsAnswers(scheduleID, storeID, 1)

                TrackingServices.addTracking(checkOutID, TRACKINGS_TYPES.CHECKOUT, 'StoreDetail')

                if (status_send) {
                    //solo pasa a bloqueado si hay conexion
                    await updateStatusForms(FORM_SCHEDULE_STATUS.BLOCKED)
                }
                // Actualiza campaign_status en el contexto global de la tienda
                updateStoreStatus(newStoreId, status_store)

                setStoreStatus(newStoreId, status_store)

                validateStatusCheckOut()
            } catch (error) {
                console.error(error)
            } finally {
                setCheckoutInProcess(false)
                closeBottomSheet(true)
                navigation.goBack()
            }
        }
    }

    const generateKpiForms = async (formsIds, storeId, scheduleId) => {
        try {
            const forms = await schedulesServices.getFormsByIds(formsIds)
            // console.log('forms => ', forms.length)

            // forms a sumar
            const formsWeigh = forms
                .map((form) => {
                    return {
                        form_id: form._id,
                        weigh: form.weigh || null,
                    }
                })
                .filter((form) => form.weigh !== null)
            // console.log('formsWeigh => ', JSON.stringify(formsWeigh))
            const formsIdsWeigh = formsWeigh.map((form) => form.form_id)
            // console.log('formsIdsWeigh => ', formsIdsWeigh)

            // forms progres realizados
            const fqa = await schedulesServices.getFQAByStore(formsIdsWeigh, storeId, scheduleId)

            const formsRealized = fqa.map((form) => {
                return {
                    form_id: form.form_id,
                    form_name: form.form_name,
                    progress: form.progress_questions_yes_na || 0,
                    status_send: form.status_send || 0,
                }
            })
            // console.log('formsRealized => ', JSON.stringify(formsRealized.length))

            const formsFinal = formsRealized.map((form) => {
                const formWeighObj = formsWeigh.find((f) => f.form_id === form.form_id)

                return {
                    form_id: form.form_id,
                    form_name: form.form_name,
                    progress: form.progress,
                    status_send: form.status_send,
                    weigh: formWeighObj ? formWeighObj.weigh : null,
                }
            })

            // console.log('formsFinal => ', JSON.stringify(formsFinal))

            let PS = formsFinal.reduce((acc, f) => {
                const score = Number(f.progress) || 0
                const weigh = f.weigh.toString().includes('.') ? Number(f.weigh) : Number(`0.${f.weigh}`)
                return acc + (isNaN(weigh) ? 0 : score * weigh)
            }, 0)
            // Redondear PS a 0 decimales si es exactamente 100, sino dejar como está
            console.log('PS BEFORE=======> ', PS)
            // if (PS === 100) {
            //     PS = 100
            // } else {
            //     PS = Math.min(100, Math.max(0, PS))
            // }
            if (PS > 100) {
                PS = 100
            } else {
                PS = parseFloat(PS.toFixed(2))
            }
            console.log('PS =======> ', PS)

            let KPI = [
                {
                    kpi: 'Perfect Store',
                    value: PS,
                    index: 0,
                    type: 'percentage',
                    criticalMomentCode: '',
                },
            ]
            // TODO: agregar funcion para que guarde el registro local..
            await schedulesServices.updateStoreKPIS(storeId, KPI)
            return
        } catch (error) {
            console.error('Error en generateKpiForms:', error)
            return
        }
    }

    const getCheckinId = async (checkinIdToSend: any) => {
        if (isValidMongoId(checkinIdToSend)) {
            return checkinIdToSend
        }
        let dataCheckinID = checkinIdToSend
        // let dataCheckinIDLocal = ''
        const dataCheckin = await schedulesServices.get_checkin(storeID, scheduleID)

        if (dataCheckin) {
            const index = dataCheckin.length - 1
            // dataCheckinIDLocal = dataCheckin[index]._id
            dataCheckinID = dataCheckin[index].checkin_id
        } else {
            //alert(No se encontra el checkin.)
            alert(languageFile.no_checkin_found)
            return
        }
        return dataCheckinID
    }

    const createDataFormsSend = async (store_id, schedule_id) => {
        try {
            // console.log('store_id => ', store_id)
            // console.log('schedule_id => ', schedule_id)
            const { existsInDB, _id_mongoDB } = await schedulesServices.getExistsInDB(store_id)

            const generateIdDate = generateIdDateNow()

            const formsInStore = await schedulesServices.getFormsRealizedByStore(scheduleID, storeID, _id_mongoDB, generateIdDate)

            const formContextView = formsContext.map((form) => {
                return {
                    activity_id: form._id,
                    date: null,
                    status: getStatus(form.status),
                    form_name: form.name_form,
                    count: 1,
                }
            })

            // console.log('formContextView => ', JSON.stringify(formContextView))

            const dataFormsInStore = []

            for (const form of formsInStore) {
                const existingForm = dataFormsInStore.find((item) => item.activity_id === form.form_id)

                if (existingForm) {
                    // Si ya existe, aumentar el count
                    existingForm.count += 1
                } else {
                    // Si no existe, agregarlo al array
                    dataFormsInStore.push({
                        activity_id: form.form_id,
                        date: form.date_init,
                        status: getStatus(form.status),
                        form_name: form.name_form,
                        count: 1,
                    })
                }
            }

            for (const form of formContextView) {
                const exists = dataFormsInStore.some((item) => item.activity_id === form.activity_id)
                if (!exists) {
                    dataFormsInStore.push({
                        ...form,
                        date: form.date || new Date(),
                    })
                }
            }

            return dataFormsInStore
        } catch (error) {
            console.error('Error en findFormsRealizedInStore:', error)
            return []
        }
    }

    const getStatus = (statusRegister: number) => {
        const { PENDING, COMPLETED, IN_PROGRESS, PENDING_CONNECTION } = FORM_SCHEDULE_STATUS

        const NO_REALIZED = 0
        const REALIZED = 1
        const NO_FINISH = 2

        const map = {
            [PENDING]: NO_REALIZED, // PENDING -> No lo realizó
            [COMPLETED]: REALIZED, // COMPLETED -> Lo realizó
            [PENDING_CONNECTION]: REALIZED, // COMPLETED -> Lo realizó
            [IN_PROGRESS]: NO_FINISH, // IN_PROGRESS -> Lo realizó pero no lo terminó
        }

        return map[statusRegister] || statusRegister
    }

    const sendFormsRealizedStore = async () => {
        try {
            const hasConnection = await validateConnectionNetwork()

            const resFormsPending = await findFormsRealizedInStore()

            if (hasConnection) {
                const resFormsPending = await findFormsRealizedInStore()
                // console.log('1538 -- 🚀 ~ sendFormsRealizedStore ~ resFormsPending:', resFormsPending)
                let status_send = 0
                for (const formPending of resFormsPending) {
                    const form_id = formPending.form_id
                    const store_id = formPending.store_id
                    const schedule_id = formPending.schedule_id
                    const register_id = formPending._id

                    let STATUS_FORM = FORM_SCHEDULE_STATUS.COMPLETED

                    const responseSendForm = await sendForm(STATUS_FORM, null, schedule_id, form_id, store_id, () => {}, register_id)

                    console.log('1785 --- responseSendForm', responseSendForm)

                    status_send = typeof responseSendForm === 'object' && responseSendForm?.send_status ? responseSendForm.send_status : (responseSendForm as number)

                    if (status_send) {
                        console.log('==============>>🚚 envio el form', form_id)
                        await schedulesServices.updateStatusFormAnswerSchedule(
                            FORM_SCHEDULE_STATUS.COMPLETED,
                            schedule_id,
                            form_id,
                            store_id,
                            'PENDING_CONNECTION',
                            register_id,
                        )
                        //agrego la actualizacion de status en la nueva key status_send
                        await schedulesServices.updateStatusSendForm(
                            FORM_SCHEDULE_STATUS.COMPLETED,
                            schedule_id,
                            form_id,
                            store_id,
                            'error al enviar form PENDING_CONNECTION',
                            register_id,
                        )
                    }
                }
            } else {
                // pasar la key checkout a false
                for (const formPending of resFormsPending) {
                    const register_id = formPending._id
                    const statusCheckout = false
                    await schedulesServices.updateKeyCheckoutFQA(statusCheckout, register_id)
                }
            }
        } catch (error) {
            console.error('sendFormsRealizedStore: ', error)
        }
    }

    /**
     * @description llama a las funciones de validacion de forms, en caso de que pase las valiaciones ejecuta la funcion checkout
     */
    const validates_forms = async () => {
        try {
            setLoadingCheckout(true)
            const validate = await validate_forms_relevant() //aca valido si realizo los forms obligatorios
            // console.log('1704 --  constvalidates_forms= ~ validate:', validate)

            if (validate.status === 1) {
                // si no tengo obligatorios, verifico si tengo pendientes..
                let view_modal = false
                let data = {
                    title: 'Tienes acciones pendientes antes de finalizar',
                    message: '',
                    form_id: null,
                }

                let index = 0

                const validate_forms = validate_forms_in_progress_pending()
                const validate_forms_objective = validate_forms_schedule_objective()

                // const getFormPending = get_names_forms_pendings() // nuevo

                if (validate_forms_objective.status !== 1) {
                    // tengo forms Objectives pendientes entonces muestro modal
                    view_modal = true
                    index = formsContext.findIndex((formContext) => formContext._id === validate_forms_objective.form_id)
                    data.message = data.message.concat(data.message != '' ? '\n' : '', validate_forms_objective.message)
                }
                if (validate_forms.status !== 1) {
                    // tengo forms en curso entonces muestro modal
                    view_modal = true
                    index = formsContext.findIndex((formContext) => formContext._id === validate_forms.form_id)
                    data.message = data.message.concat(data.message != '' ? '\n' : '', validate_forms.message)
                }

                // if (getFormPending && getFormPending.status !== 1) {
                //     view_modal = true
                //     index = formsContext.findIndex((formContext) => formContext._id === validate_forms_objective.form_id)

                //     setValidateCheckout((prev) => {
                //         return {
                //             isPosibleCheckout: prev.isPosibleCheckout,
                //             messageValidateCheckout: getFormPending.message,
                //         }
                //     })
                // }

                if (view_modal) {
                    await checkOut()

                    // setValidateCheckout((prev) => {
                    //     return {
                    //         isPosibleCheckout: true,
                    //         messageValidateCheckout: prev.messageValidateCheckout,
                    //     }
                    // })

                    // openBottomSheet(
                    //     <GotoForm
                    //         data={data}
                    //         closeBottomSheet={closeBottomSheet}
                    //         navigateToForms={navigateToForms}
                    //         indexForm={index}
                    //         title={data.title}
                    //         button
                    //         checkOut={() => checkOut()}
                    //     />,
                    // )
                } else {
                    await checkOut()
                    // confirmCheckOut() // MODAL CONFIRM CHECKOUT
                }
            } else {
                let view_model = false
                let message = ''
                // si me faltan completar formularios obligatorios, muestro el modal
                // alert(validate.message)
                let index = formsContext.findIndex((formContext) => formContext._id === validate.form_id)

                if (index != -1) {
                    const form = formsContext[index]

                    const form_name = form['name_form']

                    if (form_name != null && form_name != undefined) {
                        message = `⚠️ Obligatorio: ${form_name}`
                        view_model = true
                    }
                }
                if (isUserBlocked()) {
                    // console.log('1120 ---- isUserBlocked: ', isUserBlocked())
                    console.log('1121 --- estoy en periodo de moderacion y tengo forms obligatorios')
                    // si estoy en periodo de moderacion y tengo forms obligatorios, debo dejar hacer checkout
                    await checkOut()
                    return
                }

                if (view_model) {
                    setValidateCheckout({
                        isPosibleCheckout: true,
                        messageValidateCheckout: message,
                    })
                }

                // let title = languageFile.checkout_blocked
                // const snapPoints = ['40%']
                // const indexForm = formsContext.findIndex((formContext) => formContext._id === validate.form_id)
                // console.log('formContext.length => ', formsContext.length)
                // const form = formsContext.find((formContext) => formContext._id === validate.form_id)

                // openBottomSheet(
                //     <GotoForm
                //         data={validate}
                //         title={title}
                //         closeBottomSheet={closeBottomSheet}
                //         navigateToForms={navigateToForms}
                //         indexForm={indexForm}
                //     />,
                // )
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoadingCheckout(false)
        }
    }

    const confirmCheckOut = async () => {
        const snapPoints = [fontScale > 1 ? '75%' : '55%']

        const title = languageFile.want_to_check_out
        const description = languageFile.not_check_in_again
        const buttonConfirm = languageFile.confirm
        const buttonCancel = languageFile.cancel

        openBottomSheet(
            <BottomSheetAlert
                image={require('../../../assets/stores/existingStore.png')}
                title={title}
                desc={description}
                button={buttonCancel}
                closeBottomSheet={closeBottomSheet}
                buttonGoto={buttonConfirm}
                goto={checkOut}
            />,
            snapPoints,
        )
    }

    const checkLocationFn = async () => {
        try {
            setStartAnimationLoaderUbi(true)
            await checkLocation()
        } catch (error) {
            console.error('checkLocationFn error:', error)
        } finally {
            setStartAnimationLoaderUbi(false)
        }
    }

    const renderButtonStore = useCallback(() => {
        switch (statusCheckin) {
            case CHECKIN_PENDIENTE:
                return (
                    <View style={{ flex: 1 }}>
                        <TouchableOpacity onPress={() => checkIn()} style={styles.checkInOutButton} disabled={loadingCheckin}>
                            {loadingCheckin ? (
                                <ActivityIndicator size='small' color={'white'} style={styles.marginLeftIcon} />
                            ) : (
                                <Text style={styles.mainButtonText}>{languageFile.check_in}</Text>
                            )}
                        </TouchableOpacity>
                        {validateCheckin.isPosibleCheckin && (
                            <View style={{ marginTop: 10, flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                                <Text style={{ color: 'yellow', textAlign: 'center', fontWeight: 'bold' }}>
                                    {validateCheckin.messageValidateCheckin}
                                </Text>

                                <View style={{ marginHorizontal: 5 }} />

                                <TouchableOpacity style={stylesSchedules.iconButton} onPress={checkLocationFn}>
                                    <Animated.View style={{ transform: [{ rotate: spinRefreshUbi }] }}>
                                        <Feather name='refresh-ccw' size={iconSize} color={theme.colors.background} />
                                    </Animated.View>
                                </TouchableOpacity>
                            </View>
                        )}
                    </View>
                )
            case CHECKIN_REALIZADO:
                return (
                    <View style={{ flex: 1 }}>
                        <TouchableOpacity onPress={() => validates_forms()} style={styles.checkInOutButtonBis} disabled={loadingCheckout}>
                            {loadingCheckout ? (
                                <ActivityIndicator size='small' color={theme.colors.colorPrimary} style={styles.marginLeftIcon} />
                            ) : (
                                <Text style={styles.mainButtonTextActive}>{languageFile.check_out}</Text>
                            )}
                        </TouchableOpacity>
                        {validateCheckout.isPosibleCheckout && (
                            <View style={{ marginTop: 10 }}>
                                <Text style={{ color: 'yellow', textAlign: 'center', fontWeight: 'bold', paddingTop: 8, paddingBottom: 5 }}>
                                    {validateCheckout.messageValidateCheckout}
                                </Text>
                            </View>
                        )}
                    </View>
                )
            case CHECKOUT_REALIZADO:
                return (
                    <LinearGradient
                        style={styles.linearGradient}
                        colors={[theme.colors.colorPrimary, theme.colors.linearGradientStart]}
                        start={{ x: 0, y: 0 }}
                        end={{ x: 1, y: 0 }}
                    >
                        <Text style={styles.mainButtonText}>{languageFile.check_out_done}</Text>
                        <Feather name='check' size={iconSizeMin} color={'white'} style={styles.marginLeftIcon} />
                    </LinearGradient>
                )

            case 4:
                return (
                    <LinearGradient
                        style={styles.linearGradient}
                        colors={[theme.colors.colorPrimary, theme.colors.linearGradientStart]}
                        start={{ x: 0, y: 0 }}
                        end={{ x: 1, y: 0 }}
                    >
                        <Text style={styles.mainButtonText}>{languageFile.off_route}</Text>
                        <Feather name='x' size={16} color={'white'} style={styles.marginLeftIcon} />
                    </LinearGradient>
                )
            default:
        }
    }, [
        statusCheckin,
        formsContext,
        loadingCheckin,
        loadingCheckout,
        validateCheckout.isPosibleCheckout,
        validateCheckin.isPosibleCheckin,
        lastUpdateCoorsUser,
    ])

    /**
     * @description updateo el status de los formularios de formsContext y de la tabla SCHEDULES_STORE_NAMES.FORMS por el status que recibo por param
     * @param status number
     */
    const updateStatusForms = async (status: number) => {
        try {
            const formsNoCompleted = formsContext.filter((form) => form.status !== FORM_SCHEDULE_STATUS.COMPLETED)

            const updatedForms = formsContext.map((form: FormProps) => ({
                ...form,
                status:
                    form.status === FORM_SCHEDULE_STATUS.COMPLETED
                        ? form.status
                        : status == FORM_SCHEDULE_STATUS.BLOCKED && form.type_form.type == FORM_TYPES.FORM_MODERACION
                        ? form.status
                        : status,
            }))

            for (const form of formsNoCompleted) {
                let updateStatus = status
                if (updateStatus == FORM_SCHEDULE_STATUS.BLOCKED && form.type_form.type == FORM_TYPES.FORM_MODERACION) {
                    updateStatus = form.status
                }
                await schedulesServices.updateStatusFormAnswerSchedule(updateStatus, scheduleID, form._id, storeID) // actualizo el registro de formulario que tambien guarda las preguntas
            }
            console.log('setFormsContext 3')
            setFormsContext(updatedForms)
            setReloadChange()
        } catch (error) {
            console.error('updateStatusForms ERROR => ', error)
        }
    }

    const handleClickSet = (item: FormProps, index: number) => {
        if (item.status === FORM_SCHEDULE_STATUS.COMPLETED && !item.repeat) {
            return () => {}
        } else {
            return navigateToForms(item._id || item.name_form || index, item.name_form)
        }
    }

    const openMap = () => {
        const scheme = platformSelect({ ios: 'maps://0,0?q=', android: 'geo:0,0?q=' })
        const latLng = `${store.lat},${store.lng}`
        const label = store.name ?? languageFile.selected_store
        const url = platformSelect({
            ios: `${scheme}${label}@${latLng}`,
            android: `${scheme}${latLng}(${label})`,
        })
        //GoogleMaps iOS  // const browser_url = 'https://www.google.de/maps/@' + store.lat + ',' + store.lng + '?q=' + label
        Linking.openURL(url)
    }

    const updateVoucher = (item) => {
        const updatedVouchers = vouchers.map((voucher) => (voucher._id === item._id ? item : voucher))
        setVouchers(updatedVouchers)
    }

    const updateStatusStoreAndCreateAdvance = async (status: number, textAnswer: string) => {
        try {
            const objetives = await createObjetives()

            await schedulesServices.upsertScheduleAdvanceLocal(scheduleID, storeID, status, new Date().toISOString(), [], objetives, textAnswer)

            await schedulesServices.update_status_store(storeID, scheduleID, status, new Date().toISOString())

            updateStoreStatus(storeID, status)
        } catch (error) {
            console.error('updateStatusStoreAndCreateAdvance => ', error)
        }
    }
    const createObjetives = async () => {
        let objetives = []
        try {
            let schedule = await schedulesServices.get_schedule(scheduleID)
            if (
                schedule &&
                schedule.additional &&
                schedule.additional.objective &&
                schedule.additional.objective.length > 0 &&
                schedule.additional.objective.some((item) => item.type == CONSTANTS_TYPES_STEPS.OBJECTIVES_BY_FORMS_GROUP)
            ) {
                let steps_group_forms = schedule.additional.objective.find((item) => item.type == CONSTANTS_TYPES_STEPS.OBJECTIVES_BY_FORMS_GROUP)
                if (steps_group_forms && steps_group_forms.form.length > 0 && steps_group_forms.name_required.length > 0) {
                    let get_names_forms = await schedulesServices.get_name_forms(steps_group_forms.name_required, steps_group_forms.form, forms)
                    objetives = get_names_forms
                }
            }
        } catch (error) {
            console.error('createObjetives => ', error)
        } finally {
            return objetives
        }
    }
    const actionButonSendIncidence = async (statusIncidence: number, incidenteResponse: string) => {
        try {
            setIsIncidenceReport(true)
            closeBottomSheet(true)
            if (statusIncidence != null && incidenteResponse != null) {
                setStatus_store(statusIncidence)
                await updateStatusStoreAndCreateAdvance(statusIncidence, incidenteResponse)
                setButtonIncidenceText(incidenteResponse)
                navigation.goBack()
            }
        } catch (error) {
            console.error('🚀 ~ actionButonSendIncidence ~ error', error)
        }
    }

    const handleNotifyIncident = async () => {
        try {
            let { status, store, schedule_advances } = await schedulesServices.validateCheckins(scheduleID)

            console.log('🚀 ~ checkIn ~ status:', status, schedule_advances)
            //valido fechaa
            let fecha_hoy = new Date()
            let offset = fecha_hoy.getTimezoneOffset()
            // Convertir la fecha y hora actual de UTC a la zona horaria local del usuario
            fecha_hoy.setMinutes(fecha_hoy.getMinutes() - offset)

            let fecha_hoy_str = fecha_hoy.toISOString().split('T')[0]

            console.log(status, '-----------fecha de hoyyy ~ fecha_hoy:', fecha_hoy_str, schedule_advances)

            if (!status && schedule_advances && schedule_advances.date_init < fecha_hoy_str) {
                console.log('-----------esta vencidoo~ fecha_hoy:', fecha_hoy_str, schedule_advances.date_init)
                status = true
            }
            if (!status) {
                let title = 'Incidencia bloqueada'
                let desc = languageFile.close_the_open_checkin
                let button = languageFile.accept

                if (store && store.name && store.code) {
                    desc = languageFile.close_the_checkin_opened_in + `${store.name}, ${store.code}`
                }

                return openBottomSheet(
                    <BottomSheetAlert
                        image={require('../../../assets/stores/checkinLocked.png')}
                        title={title}
                        desc={desc}
                        button={button}
                        closeBottomSheet={closeBottomSheet}
                    />,
                    ['50%'],
                )
            }
        } catch (error) {
            console.error('🚀 ~ handleNotifyIncident ~ error', error)
        }
        const cordUser = {
            lat: userLat,
            lng: userLng,
            last_update_coords: lastUpdateCoorsUser,
        }
        const canValidateDistance = validateUpdateCoordsTime(lastUpdateCoorsUser)

        const isValidDistanceCheckin = await schedulesServices.isValidDistanceCheckin(storeID, cordUser)

        if (!isValidDistanceCheckin && canValidateDistance) {
            setValidateCheckin({
                isPosibleCheckin: true,
                messageValidateCheckin: '🚫 Estás fuera de los 50mts.',
            })
            return
        }

        if (formIncidence) {
            openBottomSheet(
                <View style={{ flex: 1 }}>
                    <Image
                        style={[stylesScheduleDistributor.image, { alignSelf: 'center' }]}
                        source={require('../../../assets/reportIncident.png')}
                    />

                    <FormView
                        key={formIncidence?._id}
                        formContent={formIncidence?.contents}
                        // hideOrShow={hideOrShow}
                        hideOrShow={() => {}}
                        form_id={formIncidence?._id}
                        store_id={storeID}
                        schedule_id={scheduleID}
                        repeat={formIncidence?.repeat}
                        progress={formIncidence?.progress}
                        totalScore={formIncidence?.totalScore}
                        clearRegisterDatabaseLocal={null}
                        hasFinishSheet={false}
                        reloadHideShowData={null}
                        tags={[]}
                        onClickTag={() => {}}
                        formType={formIncidence?.type_form.type}
                        actionButonSend={actionButonSendIncidence}
                        formTypeObj={formIncidence.type_form}
                    />
                    <TouchableOpacity
                        style={[stylesScheduleDistributor.borderButton, { marginTop: -16, borderColor: theme.colors.colorPrimary }]}
                        onPress={() => closeBottomSheet(true)}
                    >
                        <Text style={styles.borderButtonText}>Cancelar</Text>
                    </TouchableOpacity>
                    <View style={stylesScheduleDistributor.spacer}></View>
                    <View style={stylesScheduleDistributor.spacer}></View>
                </View>,
            )
        }
    }

    useEffect(() => {
        console.log('useEffect StoreDetail 1')
        if (fontScale > 1) {
            setIconSize(24) // Cambiar iconSize si el tamaño de la fuente es más grande
        } else {
            setIconSize(20) // Valor normal
        }

        askAgain()
        loadData()
        setStoreStatus(storeID, status_store)

        return () => {
            setFormsContext([])
        }
    }, [])

    useCallback(() => {
        console.log('useEffect StoreDetail 2')
        validateStatusCheckin()
        calculateRelevProgress()
    }, [statusSteps, formsContext])

    useEffect(() => {
        console.log('useEffect StoreDetail 3')
        fetchDataLocalNew().finally(() => {
            setLoading(false)
            fetchDataOnlineNew()
        })
    }, [reloadForms])

    useEffect(() => {
        console.log('useEffect StoreDetail 4')
        if (formsContext.length > 0) {
            let indicators = false
            for (let i = 0; i < formsContext.length; i++) {
                if (formsContext[i].mandatory == true) {
                    indicators = true
                    break
                }
            }
            setShowIndicators(indicators)
        }
    }, [formsContext])

    useEffect(() => {
        console.log('useEffect StoreDetail 5')
        if (navigate_form && formsContext.length > 0) {
            const timer = setTimeout(() => {
                const indexForm = formsContext.findIndex((formContext) => formContext._id == navigate_form)
                if (indexForm !== -1) {
                    navigateToForms(indexForm)
                }
            }, 1000)
            return () => clearTimeout(timer)
        }
    }, [navigate_form && formsContext.length > 0])

    useEffect(() => {
        console.log('useEffect StoreDetail 6')
        const unsubscribeFocus = navigation.addListener('focus', () => {
            setValidateCheckout({
                isPosibleCheckout: false,
                messageValidateCheckout: '',
            })
            setValidateCheckin({
                isPosibleCheckin: false,
                messageValidateCheckin: '',
            })
        })
        return unsubscribeFocus
    }, [navigation])
    const getFreq = () => {
        let freq = ''
        if (!store) return freq
        if (store.frequency && store.frequency != '') {
            freq = store.frequency
            return freq
        }
        if (store.additional && store.additional.length > 0) {
            let value = store.additional.find((item) => item.label === 'frequencia')
            if (value && value != undefined) {
                freq = value.value
                return freq
            }
        }
        return freq
    }
    const getTopStore = () => {
        let top = ''
        if (!store) return top
        if (store.topstore && store.topstore != '') {
            top = store.topstore
            return top
        }
        if (store.additional && store.additional.length > 0) {
            let value = store.additional.find((item) => item.label === 'topstore')
            if (value && value != undefined) {
                top = value.value
                return top
            }
        }
        return top
    }
    const getPotencial = () => {
        let pot = ''
        if (!store) return pot
        if (store.potencial && store.potencial != '') {
            pot = store.potencial
            return pot
        }
        if (store.additional && store.additional.length > 0) {
            let value = store.additional.find((item) => item.label === 'potencial')
            if (value && value != undefined) {
                pot = value.value
                return pot
            }
        }
        return pot
    }
    const frequency = getFreq()
    const topStore = getTopStore()
    const potencial = getPotencial()
    const RenderIndicence = useMemo(() => {
        if (isIncidenceReport) {
            return (
                <View style={stylesCampaingView.containerStoreClose}>
                    <MaterialCommunityIcons name='store-alert-outline' size={24} color='white' />
                    <Text style={[{ marginLeft: 8, marginTop: 1, color: 'white', fontWeight: '700' }]}>{buttonIncidenceText}</Text>
                </View>
            )
        }

        return <></>
    }, [isIncidenceReport, status_store, buttonIncidenceText])

    const RenderNotifyIndicence = useMemo(() => {
        if (canFormIncidence) {
            return (
                <TouchableOpacity
                    style={[styles.checkInOutButton, { backgroundColor: 'rgba(0, 0, 0, 0.2)', marginHorizontal: 0, marginRight: 10, maxHeight: 45 }]}
                    onPress={() => handleNotifyIncident()}
                >
                    <Image style={{ width: 20, height: 20 }} source={require('../../../assets/icon_incidencia.png')} />
                </TouchableOpacity>
            )
        }
        return <></>
    }, [canFormIncidence])
    const [kpis, setKpis] = useState<any[]>([])

    const getIndicators = (forms: FormProps[], kpis: KpisIndicators[]): Array<FormProps | any> => {
        try {
            let indicators: Array<FormProps | KpisIndicators> = []

            if (kpis && kpis.length > 0) {
                let mapKpis = kpis
                    .map((kpi, index) => {
                        let _id = Math.random().toString(36).substring(2, 15) // Genera un ID único aleatorio
                        return {
                            ...kpi,
                            _id: _id,
                            isKPI: true,
                        }
                    })
                    .sort((a, b) => a.index - b.index)
                // console.log('Cantidad de KPIS:', mapKpis.length)
                // console.log('KPIS', mapKpis)
                indicators = indicators.concat(mapKpis)
            }
            if (forms && forms.length > 0) {
                let mandatoryForms = forms.filter((form) => form.mandatory == true)
                if (mandatoryForms && mandatoryForms.length > 0) {
                    indicators = indicators.concat(mandatoryForms)
                }
                // console.log('Cantidad de Forms mandatorios:', mandatoryForms.length)
            }
            if (indicators.length > 0) {
                setShowIndicators(true)
            }
            const filteredIndicators = filterIndicators(indicators)
            console.log('Cantidad de Indicadores:', indicators.length, 'Cantidad de Indicadores filtrados: ', filteredIndicators.length)
            // console.log('Cantidad de Indicadores filtrados:', filteredIndicators.length)

            return filteredIndicators
        } catch (error) {
            console.error('Error in getIndicators:', error)
            return []
        }
    }

    const filterIndicators = (indicators) => {
        try {
            if (!indicators || indicators.length === 0) return []

            const seen = new Set()
            const result = []

            for (const item of indicators) {
                if (item.isKPI === true) {
                    const name = item.kpi.toUpperCase().trim()
                    if (!seen.has(name)) {
                        seen.add(name)
                        result.push(item)
                    }
                }
            }

            for (const item of indicators) {
                if (item.isKPI !== true) {
                    const name = item.name_form.toUpperCase().trim()
                    if (!seen.has(name)) {
                        seen.add(name)
                        result.push(item)
                    }
                }
            }

            return result
        } catch (error) {
            console.error('Error in filterIndicators:', error)
            return indicators || []
        }
    }

    const indicatorsMemoized = useMemo(() => getIndicators(formsContext, kpis), [formsContext, kpis])
    // console.log('indicatorsMemoized', indicatorsMemoized.length)
    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <View style={styles.container}>
                    <ScrollView
                        showsVerticalScrollIndicator={false}
                        style={[isIncidenceReport && status_store == STORE_STATUS.INCIDENCE_REPORTED_PERMANENTE ? { pointerEvents: 'none' } : null]}
                    >
                        {store && (
                            <>
                                <LinearGradient
                                    style={[styles.containerStoreData, { marginBottom: vouchers.length > 0 ? 4 : 20 }]}
                                    colors={[theme.colors.linearGradientStart, theme.colors.linearGradientEnd]}
                                    start={{ x: 0, y: 0 }}
                                    end={{ x: 1, y: 0 }}
                                >
                                    <View style={styles.containerNameStore}>
                                        {/* <Image
                                            style={[styles.storeImage, { width: iconSize, height: iconSize }]}
                                            source={require('../../../assets/stores/store.png')}
                                        /> */}
                                        <MaterialCommunityIcons
                                            name='store'
                                            size={24}
                                            color={'white'}
                                            style={[styles.marginRightExecution, styles.marginBottom1]}
                                        />
                                        {/* <Feather name='map-pin' size={iconSize} color={'black'} style={[styles.marginRightExecution, styles.marginBottom]}/> */}
                                        <Text numberOfLines={2} style={styles.textNameStore}>
                                            {store.name ?? ''}
                                        </Text>
                                    </View>

                                    <View style={styles.containerDataStore}>
                                        <Text style={styles.storecode}>
                                            {store.code ? store.code + '  |  ' : ''}
                                            {store.cluster ? store.cluster + '  |  ' : ''}
                                            {potencial && potencial != '' ? potencial + '  |  ' : ''}
                                            {frequency && frequency != '' ? frequency + '  |  ' : ''}
                                            {topStore && topStore != '' ? topStore + '  |  ' : ''}

                                            <Feather name='map-pin' size={13} color={'white'} />
                                            {store.distance ? ' ' + store.distance + '  ' : ' '}
                                        </Text>

                                        {/* {store.additional && <StoreAdditionalView additional={store.additional} />}

                                        {store.cluster && <Text style={[styles.textInfoStore]}> | {store.cluster}</Text>} */}

                                        {/* {store.distance && store.cluster && store.cluster.length < 13 && fontScale <= 1 && (
                                            <View style={styles.containerDataStoreBis}>
                                                <Text style={styles.colorWhite}> | </Text>
                                                <Feather name='map-pin' size={13} color={'white'} />
                                                <Text numberOfLines={2} style={[styles.colorWhite, styles.marginStart]}>{store.distance}</Text>
                                            </View>
                                        )} */}
                                    </View>

                                    <TouchableOpacity onPress={openMap} style={[styles.containerRow, { marginHorizontal: 11 }]}>
                                        {/* <Feather name='navigation' size={iconSize} color={'white'} style={[styles.marginRight, styles.marginTop2]} /> */}
                                        <Text style={styles.textAddressStoreWithGoTo}>{store.address ?? ''}</Text>
                                    </TouchableOpacity>
                                    {(store.distance && store.cluster && store.cluster.length >= 13) ||
                                        (fontScale > 1 && (
                                            <View style={styles.containerDistance}>
                                                <Feather name='map-pin' size={iconSize} color={'white'} />
                                                <Text style={[styles.colorWhite, styles.marginStart]}>{store.distance}</Text>
                                            </View>
                                        ))}
                                    {/* <Progress.Bar
                                        progress={progressRelev / 100}
                                        height={12}
                                        width={width - 25}
                                        style={styles.progress}
                                        color='white' //{theme.colors.colorTertiary}
                                        unfilledColor= 'black'
                                    />
                                    {expoConfig.slug != 'kimberly-one' && (
                                        <View style={styles.containerInfoStore}>
                                            <Text style={styles.textInfoStore}>{languageFile.survey}</Text>
                                            <Text style={styles.textProgressStore}>{progressRelev}%</Text>
                                        </View>
                                    )} */}
                                    {RenderIndicence}
                                    <View
                                        style={{
                                            flexDirection: 'row',
                                            marginTop: 15,
                                        }}
                                    >
                                        {renderButtonStore()}
                                        {statusCheckin == CHECKIN_PENDIENTE && RenderNotifyIndicence}
                                    </View>
                                </LinearGradient>
                            </>
                        )}

                        {/* INDICADORES DE TIENDA */}
                        {indicatorsMemoized.length > 0 && (
                            <>
                                <View style={styles.containerSection}>
                                    <View style={styles.subContainerSection}>
                                        <View style={{ flex: 7 }}>
                                            <Text style={styles.textSection}>{languageFile.store_indicators}</Text>
                                            <Text style={[styles.textSectionDescription, styles.maxWidth]}>{languageFile.main_indicators}</Text>
                                            {!showMore && <View style={{ marginBottom: 0 }}></View>}
                                        </View>
                                        <TouchableOpacity style={{ flex: 1 }} onPress={() => setShowMore(!showMore)}>
                                            <Feather
                                                name={!showMore ? 'chevron-down' : 'chevron-up'}
                                                size={iconSize}
                                                color={theme.colors.colorPrimary}
                                            />
                                        </TouchableOpacity>
                                    </View>
                                    {showMore && (
                                        <FlashList
                                            style={{ marginTop: 10, minHeight: 185, maxHeight: 185, marginBottom: 10 }}
                                            data={indicatorsMemoized}
                                            keyExtractor={(item) => item._id}
                                            horizontal={true}
                                            nestedScrollEnabled={true}
                                            showsHorizontalScrollIndicator={false}
                                            renderItem={({ item: item, index }) => (
                                                <View>
                                                    {item.isKPI && item.isKPI === true ? (
                                                        <StoreKPIIndicators item={item} index={index} onClickItem={() => {
                                                            if (statusCheckin === CHECKIN_REALIZADO) {
                                                                    console.log('1292 StoreFormButtonsIndicators --- entre aca', item.status)
                                                                    if (
                                                                        item.status != FORM_SCHEDULE_STATUS.COMPLETED &&
                                                                        item.status != FORM_SCHEDULE_STATUS.PENDING_CONNECTION
                                                                    )
                                                                        navigateToForms(item._id || item.name_form || index, item.name_form)
                                                                } else if (
                                                                    statusCheckin === CHECKOUT_REALIZADO &&
                                                                    item.type_form.type === FORM_TYPES.FORM_MODERACION &&
                                                                    item.status === FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION
                                                                ) {
                                                                    console.log('1295 StoreFormButtonsIndicators --- entre aca')
                                                                    navigateToForms(item._id || item.name_form || index, item.name_form)
                                                                }
                                                        }} />
                                                    ) : (
                                                        <StoreFormButtonsIndicators
                                                            name={item.name_form}
                                                            image={item.icon}
                                                            index={index}
                                                            // onClickItem={statusCheckin === CHECKIN_REALIZADO ? () => navigateToForms(item._id || index) : () => {}}
                                                            onClickItem={() => {
                                                                if (statusCheckin === CHECKIN_REALIZADO) {
                                                                    console.log('1292 --- entre aca', item.status)
                                                                    if (
                                                                        item.status != FORM_SCHEDULE_STATUS.COMPLETED &&
                                                                        item.status != FORM_SCHEDULE_STATUS.PENDING_CONNECTION
                                                                    )
                                                                        navigateToForms(item._id || index)
                                                                } else if (
                                                                    statusCheckin === CHECKOUT_REALIZADO &&
                                                                    item.type_form.type === FORM_TYPES.FORM_MODERACION &&
                                                                    item.status === FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION
                                                                ) {
                                                                    console.log('1295 --- entre aca')

                                                                    navigateToForms(item._id || index)
                                                                }
                                                            }}
                                                            isCompleted={item.complete}
                                                            columns={4}
                                                            form={item}
                                                            checkout={statusCheckin === CHECKOUT_REALIZADO}
                                                        />
                                                    )}
                                                </View>
                                            )}
                                            scrollEnabled={true}
                                            ListFooterComponent={<View style={styles.marginHorizontal} />}
                                            // estimatedItemSize removed for TS compatibility
                                        />
                                    )}
                                </View>
                            </>
                        )}

                        {isLoadingPerfectStore && hasShowProgress() ? (
                            <Loader />
                        ) : (
                            perfectStoreArray.length > 0 && (
                                <>
                                    <View style={styles.containerSection}>
                                        <View>
                                            <Text style={[styles.textSection, { marginTop: formsContext.length > 0 && showIndicators ? 30 : 0 }]}>
                                                {languageFile.perfect_store}
                                            </Text>
                                            <Text style={styles.textSectionDescription}>{languageFile.store_information}</Text>
                                        </View>
                                        <FlatList
                                            style={styles.flatList}
                                            keyExtractor={(item) => item?._id.toString()}
                                            data={perfectStoreArray}
                                            horizontal={false}
                                            showsVerticalScrollIndicator={false}
                                            renderItem={({ item: item, index }) => (
                                                <StoreFormButtons
                                                    name={item.title}
                                                    image={item.icon}
                                                    index={index}
                                                    onClickItem={navigateToPF}
                                                    isCompleted={false}
                                                    columns={4}
                                                />
                                            )}
                                            numColumns={4}
                                            scrollEnabled={false}
                                        />
                                        {/* <FlashList
                                                data={get_ejecutions_fa}
                                                horizontal
                                                nestedScrollEnabled
                                                showsHorizontalScrollIndicator={false}
                                                ItemSeparatorComponent={() => <View style={{ marginVertical: 0 }} />}
                                                renderItem={({ item, index }) => (
                                                    <TouchableOpacity onPress={() => navigateToFa(item)}>
                                                        <Text>Fiel Assesment</Text>
                                                    </TouchableOpacity>
                                                )}
                                            /> */}
                                    </View>
                                </>
                            )
                        )}

                        {/* ----------EXECUTION---------- */}
                        {memorizedForms.length > 0 && (
                            <>
                                {loadingExecution ? (
                                    <Loader />
                                ) : (
                                    <View style={styles.containerSection}>
                                        <View style={[styles.containerRow, styles.marginTop]}>
                                            <View>
                                                <View style={fontScale <= 1 ? styles.flexDirectionRow : styles.flexDirectionColumn}>
                                                    <Text style={styles.textSection}>{languageFile.execution}</Text>

                                                    {fontScale > 1 && <View style={styles.separator}></View>}

                                                    {statusCheckin === CHECKOUT_REALIZADO ? (
                                                        <View
                                                            style={[
                                                                fontScale <= 1 ? styles.marginLeft : styles.marginLeftIcon,
                                                                styles.flexDirectionRow,
                                                            ]}
                                                        >
                                                            <View style={styles.stamp}>
                                                                <Text style={styles.textCheckInOut}>{languageFile.check_out_done}</Text>
                                                                <Feather
                                                                    name='check'
                                                                    size={iconSize}
                                                                    color={theme.colors.colorApproved}
                                                                    style={styles.marginLeft}
                                                                />
                                                            </View>
                                                        </View>
                                                    ) : (
                                                        <View
                                                            style={[
                                                                styles.flexDirectionRow,
                                                                { opacity: statusCheckin === CHECKIN_REALIZADO ? 0 : 1 },
                                                            ]}
                                                        >
                                                            <EvilIcons
                                                                name='lock'
                                                                size={iconSize * 1.2}
                                                                color={theme.colors.colorLocked}
                                                                style={[
                                                                    styles.marginLeftExecution,
                                                                    styles.marginRightExecution2,
                                                                    styles.marginBottom,
                                                                ]}
                                                            />
                                                            <View style={styles.stamp}>
                                                                <Text style={styles.textRequires}>{languageFile.requires}</Text>
                                                                <Text style={styles.textCheckInOut}>{languageFile.check_in}</Text>
                                                            </View>
                                                        </View>
                                                    )}
                                                </View>
                                                <Text style={styles.textSectionDescription}>{languageFile.perform_executions}</Text>
                                            </View>
                                        </View>
                                        <FlatList
                                            style={styles.container}
                                            data={memorizedForms}
                                            horizontal={false}
                                            showsVerticalScrollIndicator={false}
                                            keyExtractor={(item, index) => item._id.toString()}
                                            renderItem={({ item: item, index }) => (
                                                <StoreFormButtonsExecution
                                                    name={item.name_form}
                                                    image={item.icon}
                                                    index={index}
                                                    onClickItem={() => {
                                                        if (statusCheckin === CHECKIN_REALIZADO) {
                                                            if (item.type_form.type === FORM_TYPES.FORM_REDIRECT) {
                                                                if (isConnected && hasInternet) {
                                                                    let url = item?.link
                                                                    if (url && url != '') {
                                                                        const isValidUrl = url && /^https?:\/\/[\w.-]+\.[a-z]{2,}.*$/.test(url)

                                                                        if (!isValidUrl) {
                                                                            console.log('URL inválida o no disponible:', url)
                                                                            return
                                                                        }
                                                                        console.log('Navegando a WebViewScreen', item?.link)
                                                                        const params = {
                                                                            link: item?.link,
                                                                        }
                                                                        const actionButonSend = () => {
                                                                            //navigation.goBack()
                                                                        }

                                                                        updateStatusForm(
                                                                            formsContext,
                                                                            scheduleID,
                                                                            item?._id,
                                                                            storeID,
                                                                            FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                                                                        )

                                                                        setReloadChange()

                                                                        const sedForm = async () => {
                                                                            const registerUpdated =
                                                                                await schedulesServices.updateStatusFormAnswerSchedule(
                                                                                    FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                                                                                    scheduleID,
                                                                                    item?._id,
                                                                                    storeID,
                                                                                    'sin conexion',
                                                                                )
                                                                            await schedulesServices.updateStatusSendForm(
                                                                                FORM_SCHEDULE_STATUS.PENDING_CONNECTION,
                                                                                scheduleID,
                                                                                item?._id,
                                                                                storeID,
                                                                                'sin conexion',
                                                                                registerUpdated.updatedId,
                                                                            )
                                                                        }
                                                                        sedForm()

                                                                        // navigation.navigate('WebView', params as undefined)
                                                                        openExternalLink(item?.link)
                                                                    }
                                                                } else {
                                                                    alert('Necesitas conexion para hecer este formulario ')
                                                                }
                                                            } else {
                                                                navigateToForms(item._id || item.name_form || index, item.name_form)
                                                            }
                                                        } else {
                                                            if (
                                                                [CHECKOUT_REALIZADO, CHECKIN_PENDIENTE].includes(statusCheckin) &&
                                                                item.type_form.type === FORM_TYPES.FORM_MODERACION &&
                                                                [
                                                                    FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION,
                                                                    FORM_SCHEDULE_STATUS.REFUSED,
                                                                ].includes(item.status)
                                                            ) {
                                                                navigateToForms(item._id || item.name_form || index, item.name_form)
                                                            }
                                                        }
                                                    }}
                                                    columns={4}
                                                    form={item}
                                                    formsContext={formsContext}
                                                    // scoreObtained={item.scoreObtained}
                                                    // data_form={{
                                                    //     store_id: storeID,
                                                    //     form_id: item._id,
                                                    //     schedule_id: scheduleID,
                                                    // }}
                                                    statusCheckin={statusCheckin}
                                                />
                                            )}
                                            numColumns={4}
                                            scrollEnabled={false}
                                        />
                                    </View>
                                )}
                            </>
                        )}

                        {vouchers.length > 0 && (
                            <View style={styles.containerSection}>
                                <RoundedTabs
                                    tabs={tabs}
                                    selectedIndex={selectedIndex}
                                    colorLGStart={'white'}
                                    colorLGEnd={'white'}
                                    colorSelected={theme.colors.colorPrimary}
                                    colorUnselected={'#ffffff'}
                                    color={theme.colors.darkGray}
                                    onSelectedTab={(index) => {
                                        setSelectedIndex(index)
                                    }}
                                />
                                {(() => {
                                    switch (selectedIndex) {
                                        case 0:
                                            return (
                                                <View>
                                                    <Text style={styles.textSectionDescription}>
                                                        {
                                                            'Aquí encontrarás tus vouchers disponibles, permitiéndote compartir promociones con solo escanear el código, asegurando una experiencia ágil y cómoda para quienes lo reciban.'
                                                        }
                                                    </Text>
                                                    <StoreVouchersList
                                                        vouchers={vouchers.filter((item) => item.status != 1)}
                                                        updateVoucher={updateVoucher}
                                                    />
                                                </View>
                                            )
                                        case 1:
                                            return (
                                                <View>
                                                    <Text style={styles.textSectionDescription}>
                                                        {
                                                            'Aquí verás tus vouchers canjeados, teniendo visibilidad de los canjes correctamente realizados.'
                                                        }
                                                    </Text>
                                                    <StoreVouchersList
                                                        vouchers={vouchers.filter((item) => item.status == 1)}
                                                        updateVoucher={updateVoucher}
                                                    />
                                                </View>
                                            )
                                        default:
                                            return <Text>{languageFile.there_was_a_mistake}</Text>
                                    }
                                })()}

                                <View style={styles.spacer1}></View>
                            </View>
                        )}
                    </ScrollView>
                </View>
            )}
        </>
    )
})

export const StoreAdditionalView = ({ additional }: { additional: StoreAdditionalInfo[] }) => {
    return (
        <View style={styles.flexDirectionRow}>
            {additional.map((item, index) => {
                if (item.label) {
                    switch (item.label) {
                        case 'segment':
                        case 'route':
                            return (
                                <Text key={item.id} style={styles.textInfoStore}>
                                    , {item.value}
                                </Text>
                            )
                        default:
                            return null
                    }
                }
            })}
        </View>
    )
}
export const PerfectStoreButtons = React.memo(({ perfectStore }: { perfectStore: PerfectStoreModel }) => {
    return (
        <View>
            {/* <TouchableOpacity style={styles.perfectStoreButton} onPress={() => {}}> */}
            <TouchableOpacity style={styles.perfectStoreButton} onPress={() => {}}>
                <Image source={{ uri: perfectStore.icon ? perfectStore.icon : placeholderGeneral }} style={styles.iconImage} resizeMode='contain' />
                <Text style={styles.textName}>{perfectStore.title}</Text>
            </TouchableOpacity>
        </View>
    )
})

interface StoreFormButtonsIndicatorsProps {
    name: string
    image: string
    index: number
    onClickItem: (index: number) => void
    isCompleted: boolean
    columns: number
    form: FormProps
    checkout: boolean
}

export const StoreFormButtonsIndicators = React.memo(
    ({ name, image, index, onClickItem, isCompleted, columns, form, checkout }: StoreFormButtonsIndicatorsProps) => {
        const { languageFile } = getLanguage()
        const { formsContext, reload } = useFormContext()

        const [statusForm, setStatusForm] = useState<statusFormProps>({
            status: null,
            repeat: null,
            score: null,
            progress: null,
            progress_questions_yes_na: null,
            mandatory: null,
            featured: null,
        })
        // useEffect(() => {
        //     setStatusForm({
        //         status: null,
        //         repeat: null,
        //         score: null,
        //         progress: null,
        //         progress_questions_yes_na: null,
        //         mandatory: null,
        //         featured: null,
        //     })
        // }, [index])

        //console.log('🚀 -------aca~ StoreFormButtonsIndicators ~ statusForm:', statusForm)
        useEffect(() => {
            const indexForm = formsContext.findIndex((formContext) => formContext._id === form._id)

            //  console.log('684 ----- formsContext[indexForm] : ', formsContext[indexForm].progress_questions_yes_na)

            if (indexForm !== -1) {
                setStatusForm({
                    repeat: formsContext[indexForm].repeat,
                    status: formsContext[indexForm].status,
                    score: formsContext[indexForm].scoreObtained,
                    progress: formsContext[indexForm].progress,
                    progress_questions_yes_na: formsContext[indexForm].progress_questions_yes_na,
                    mandatory: formsContext[indexForm].mandatory,
                    featured: formsContext[indexForm].featured,
                })
            }
        }, [reload, form])

        const getGradientColors = (index) => {
            const gradientIndex = index % 5
            const isInverted = Math.floor(index / 5) % 2 === 1
            const gradientStartKey = `linearGradientStart0${gradientIndex}`
            const gradientEndKey = `linearGradientEnd0${gradientIndex}`

            // console.log(`Index: ${index}, Gradient Index: ${gradientIndex}, Is Inverted: ${isInverted}`)
            // console.log(`Start Color Key: ${gradientStartKey}, End Color Key: ${gradientEndKey}`)
            // console.log(`Start Color: ${theme.colors[gradientStartKey]}, End Color: ${theme.colors[gradientEndKey]}`)

            if (isInverted) {
                return [theme.colors[gradientEndKey], theme.colors[gradientStartKey]]
            } else {
                return [theme.colors[gradientStartKey], theme.colors[gradientEndKey]]
            }
        }

        const gradientColors = (getGradientColors(index) as unknown) as readonly [string, string]

        const renderItem = ({ statusForm }) => {
            let view = -1
            if (statusForm.status === FORM_SCHEDULE_STATUS.COMPLETED && statusForm.progress) {
                view = 0
            } else if (statusForm.status === FORM_SCHEDULE_STATUS.COMPLETED && !statusForm.progress) {
                view = 1
            } else if (statusForm.status === FORM_SCHEDULE_STATUS.PENDING && !checkout) {
                view = 2
            } else if (statusForm.status === FORM_SCHEDULE_STATUS.PENDING && checkout) {
                view = 3
            } else if (statusForm.status === FORM_SCHEDULE_STATUS.IN_PROGRESS) {
                view = 2
            } else if (statusForm.status === FORM_SCHEDULE_STATUS.PENDING_CONNECTION && statusForm.progress) {
                view = 0
            }
            const render_progres = statusForm.progress_questions_yes_na ? `${Math.round(statusForm.progress_questions_yes_na)}%` : '-'

            switch (view) {
                case 0:
                    return (
                        <Progress.Circle
                            size={75}
                            progress={statusForm.progress_questions_yes_na / 100}
                            showsText={true}
                            // formatText={(progress) => `${Math.round(statusForm.progress_questions_yes_na / 100)}%`}
                            formatText={(progress) => `${render_progres}`}
                            textStyle={styles.textProgressCircle}
                            thickness={7}
                            color={'white'}
                            unfilledColor={theme.colors.colorTertiary}
                            borderWidth={0}
                            strokeCap='round'
                        />
                    )

                case 1:
                    return (
                        <View style={styles.containerImage}>
                            <Image style={styles.image} source={require('../../../assets/form_check.png')} />
                        </View>
                    )

                case 2:
                    return (
                        <View style={styles.containerImage}>
                            <Image style={styles.image} source={require('../../../assets/form_wrong.png')} />
                        </View>
                    )

                case 3:
                    return (
                        <View style={styles.containerImage}>
                            <Image style={styles.image} source={require('../../../assets/form_minus.png')} />
                        </View>
                    )
                default:
                    return (
                        <View style={styles.containerImage}>
                            <Image style={styles.image} source={require('../../../assets/form_minus.png')} />
                        </View>
                    )
            }
        }

        const handleClickSet = (status: number, repeat: boolean) => {
            // console.log('1112 ---- 🚀 ~ file: StoreDetail.tsx:595 ~ handleClickSet ~ repeat - status:', repeat, status)
            // console.log('1113 ----- status === FORM_SCHEDULE_STATUS.COMPLETED && !repeat: ', status === FORM_SCHEDULE_STATUS.COMPLETED && !repeat)
            if (status === FORM_SCHEDULE_STATUS.COMPLETED && !repeat) {
                return () => {}
            } else {
                // console.log('1115 ----------- onClickItem: ')
                return onClickItem(index)
            }
        }

        return (
            <>
                {statusForm.mandatory === true || statusForm.featured === true ? (
                    <View style={styles.containerItemsIndicators}>
                        <TouchableOpacity onPress={() => handleClickSet(statusForm.status, statusForm.repeat)}>
                            <LinearGradient style={styles.containerIndicator} colors={gradientColors} start={{ x: 0, y: 0 }} end={{ x: 1, y: 0.5 }}>
                                <Text style={[styles.textIndicatorName]} numberOfLines={1}>
                                    {name}
                                </Text>
                                {/* <Text style={styles.textIndicatorData}>98°</Text> */}
                                <View style={styles.containerProgress}>
                                    {/* PROGRESS A MODIFICAR */}
                                    {renderItem({ statusForm })}
                                </View>

                                {/*<Text style={styles.textVariation}>{languageFile.variation}</Text>
                            <Text style={styles.textViariationData}>---</Text>*/}
                                <Text style={styles.textVariation}></Text>
                            </LinearGradient>
                        </TouchableOpacity>
                    </View>
                ) : (
                    <></>
                )}
            </>
        )
    },
)

export const StoreFormButtons = ({
    name,
    image,
    index,
    onClickItem,
    isCompleted,
    columns,
}: {
    name: string
    image: string
    index: number
    onClickItem: (index: number) => void
    isCompleted: boolean
    columns: number
}) => {
    // const imagePs = 'https://resources-one.s3.us-east-2.amazonaws.com/assets/ejecucion_one/calidad.png'
    // const imagePs = useImageLoader(image, PATH_ASSETS)

    const { image: imagePs, loading } = useImageLoader(image, PATH_ASSETS)
    const numberOfLines = name.includes(' ') ? 2 : 1
    return (
        <View style={styles.containerItemsPS}>
            <TouchableOpacity style={[styles.alignCenter, { width: (width - 100) / columns }]} onPress={() => onClickItem(index)}>
                {loading ? (
                    <Loader />
                ) : (
                    <View style={{ backgroundColor: theme.colors.storeFormButtonBackground, borderRadius: 50, width: 62, height: 62 }}>
                        <Image source={{ uri: imagePs }} style={[styles.iconImage, { margin: 15 }]} resizeMode='contain' />
                    </View>
                )}
                <Text style={styles.textName} numberOfLines={numberOfLines} ellipsizeMode='tail'>
                    {name}
                </Text>
            </TouchableOpacity>
        </View>
    )
}

interface StoreFormButtonsExecutionProps {
    name: string
    image: string
    index: number
    onClickItem: (index: number) => void
    // isCompleted: boolean
    columns: number
    form: FormsModel
    // data_form: { store_id: string; form_id: string; schedule_id: string }
    // scoreObtained?: number
    statusCheckin?: number
    formsContext?: FormProps[]
}
interface statusFormProps {
    status: number | null
    repeat: boolean | null
    score?: number | null
    progress: boolean | null | number
    progress_questions_yes_na: number | null
    mandatory?: boolean | null
    featured?: boolean | null
}

export const StoreFormButtonsExecution = React.memo(
    ({ name, image, index, onClickItem, columns, form, statusCheckin, formsContext }: StoreFormButtonsExecutionProps) => {
        // console.log('me vuelvo a renderizar ? StoreFormButtonsExecution => ', name)
        const { languageFile } = getLanguage()
        const { reload } = useFormContext()

        const [statusForm, setStatusForm] = useState<statusFormProps>({
            status: null,
            repeat: null,
            score: null,
            progress: null,
            progress_questions_yes_na: null,
        })

        const { image: imageForm, loading } = useImageLoader(image, PATH_ASSETS)

        const STATUS_COMPLETE = statusForm.progress
            ? statusForm.progress_questions_yes_na != null
                ? Math.round(statusForm.progress_questions_yes_na) + '%'
                : '-'
            : languageFile.complete_mayus

        // const STATUS_COMPLETE = statusForm.progress ? statusForm.progress_questions_yes_na + '%' : languageFile.complete_mayus
        const STATUS_IN_PROGRESS = languageFile.in_progress_mayus
        const STATUS_PENDING_CONEXION = statusForm.progress
            ? statusForm.progress_questions_yes_na != null
                ? Math.round(statusForm.progress_questions_yes_na) + '%'
                : '-'
            : languageFile.complete_mayus //'SYNC.'
        const STATUS_BLOCKED = languageFile.locked_mayus
        const STATUS_PENDING = languageFile.pending_mayus
        const STATUS_PENDING_MODERACION = 'EN REVISIÓN'
        const STATUS_REFUSED = 'RECHAZADO'

        // useEffect(() => {
        //     setStatusForm({
        //         status: null,
        //         repeat: null,
        //         score: null,
        //         progress: null,
        //         progress_questions_yes_na: null,
        //     })

        //     // if (!statusForm.status) {
        //     //     setStatusForm({ status: null, repeat: null, score: null, progress: null, progress_questions_yes_na: null });
        //     // }
        // }, [])

        useEffect(() => {
            // const indexForm = formsContext.findIndex((formContext) => formContext._id === form._id)

            // if (indexForm !== -1) {
            //     setStatusForm({
            //         repeat: formsContext[indexForm].repeat,
            //         status: formsContext[indexForm].status,
            //         score: formsContext[indexForm].scoreObtained,
            //         progress: formsContext[indexForm].progress,
            //         progress_questions_yes_na: formsContext[indexForm].progress_questions_yes_na,
            //     })
            // } else {
            //     console.log('1555 form no encontrado : ', form._id)
            // }

            const indexForm = formsContext.findIndex((formContext) => formContext._id === form._id)
            if (indexForm !== -1) {
                const newStatus = {
                    repeat: formsContext[indexForm].repeat,
                    status: formsContext[indexForm].status,
                    score: formsContext[indexForm].scoreObtained,
                    progress: formsContext[indexForm].progress,
                    progress_questions_yes_na: formsContext[indexForm].progress_questions_yes_na,
                }
                if (JSON.stringify(statusForm) !== JSON.stringify(newStatus)) {
                    setStatusForm(newStatus)
                }
            }
        }, [form, reload])

        const statusText = (status: number): string => {
            const statusMap: { [key: number]: string } = {
                [FORM_SCHEDULE_STATUS.COMPLETED]: STATUS_COMPLETE,
                [FORM_SCHEDULE_STATUS.IN_PROGRESS]: STATUS_IN_PROGRESS,
                [FORM_SCHEDULE_STATUS.PENDING_CONNECTION]: STATUS_COMPLETE,
                [FORM_SCHEDULE_STATUS.BLOCKED]: STATUS_BLOCKED,
                [FORM_SCHEDULE_STATUS.PENDING]: STATUS_PENDING,
                [FORM_SCHEDULE_STATUS.PENDING_SYNC_IMAGE]: STATUS_PENDING_CONEXION,
                [FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION]: STATUS_PENDING_MODERACION,
                [FORM_SCHEDULE_STATUS.REFUSED]: STATUS_REFUSED,
            }

            return statusMap[status] || STATUS_BLOCKED
        }

        const styleSet = (status: number, repeat: boolean) => {
            // console.log('640 ------- status: ', status)
            // console.log('641 ------- repeat: ', repeat)
            if (status === FORM_SCHEDULE_STATUS.COMPLETED && !repeat) {
                return {
                    flexGrow: 0,
                    opacity: 1,
                }
            } else if (status === FORM_SCHEDULE_STATUS.BLOCKED) {
                return {
                    flexGrow: 0,
                    opacity: 0.5,
                }
            } else {
                return null
            }
        }

        const handleClickSet = (status: number, repeat: boolean) => {
            // console.log('1256 ---- 🚀 ~ file: StoreDetail.tsx:595 ~ handleClickSet ~ repeat - status:', repeat, status)
            // console.log('1257 ----- status === FORM_SCHEDULE_STATUS.COMPLETED && !repeat: ', status === FORM_SCHEDULE_STATUS.COMPLETED && !repeat)
            const validate_status = [FORM_SCHEDULE_STATUS.COMPLETED, FORM_SCHEDULE_STATUS.PENDING_CONNECTION, FORM_SCHEDULE_STATUS.PENDING_SYNC_IMAGE]
            const validateTypeForm = [FORM_TYPES.FORM_REDIRECT]
            if (validate_status.includes(status) && !repeat && !validateTypeForm.includes(form.type_form.type)) {
                return () => {}
            } else {
                // console.log('1262 ----------- onClickItem: ')
                return onClickItem(index)
            }
        }

        const formsWithPercentage = (name) => {
            if (
                name === '$DASA' ||
                name === 'DASA' ||
                name === 'SOS' ||
                name === 'Promo' ||
                name === 'Visibilidad' ||
                name === 'PDV' ||
                name === 'SURTIDO' || //Mars
                name === 'ÉXITO' || //Mars
                name === 'CLASIFICA' || //Mars
                name === 'TRAINING' || //Mars
                name === 'PROMOTORES' || //Mars
                name === 'CONTACTO' || //Mars
                name === 'COACHING' || //JTI
                name === 'VISITADO POR PRIMERA VEZ' || //JTI
                name === 'SIN PLAN DE LEALTAD' || //JTI
                name === 'CON PLAN DE LEALTAD' || //JTI
                name === 'TOP 100' || //JTI
                name === 'SURTIDO' || //Savencia
                name === 'PRECIOS' || //Savencia
                name === 'EXHIBICION' || //Savencia
                name === 'ACTIVACIÓN' || //Savencia
                name === 'SOS' || //Pfizer
                name === 'SOV' //Pfizer
            ) {
                return true
            }
            return false
        }

        const statusToColorMap = useMemo(
            () => ({
                [FORM_SCHEDULE_STATUS.COMPLETED]: formsWithPercentage(name) ? theme.colors.colorApproved : 'transparent',
                [FORM_SCHEDULE_STATUS.PENDING_CONNECTION]:
                    statusCheckin === 1 || !formsWithPercentage(name) ? theme.colors.alert : theme.colors.colorApproved,
                [FORM_SCHEDULE_STATUS.IN_PROGRESS]: theme.colors.colorInProgress,
                [FORM_SCHEDULE_STATUS.PENDING_SYNC_IMAGE]: theme.colors.colorPending,
                default: theme.colors.colorLocked,
            }),
            [statusForm.status],
        )

        const colorProgressCircle = statusToColorMap[statusForm.status] || statusToColorMap.default

        const unfilledColorProgressCircle =
            (statusForm.status === FORM_SCHEDULE_STATUS.COMPLETED && !formsWithPercentage(name)) ||
            (statusForm.status === FORM_SCHEDULE_STATUS.PENDING_CONNECTION && !formsWithPercentage(name))
                ? 'transparent'
                : theme.colors.lightGray

        const iconTintColor =
            {
                [FORM_SCHEDULE_STATUS.COMPLETED]: !formsWithPercentage(name) ? theme.colors.colorApproved : 'transparent',
                [FORM_SCHEDULE_STATUS.IN_PROGRESS]: theme.colors.colorInProgress,
                [FORM_SCHEDULE_STATUS.REFUSED]: theme.colors.colorCancelled,
                [FORM_SCHEDULE_STATUS.PENDING]: theme.colors.colorPending,
                [FORM_SCHEDULE_STATUS.PENDING_CONNECTION]: !formsWithPercentage(name)
                    ? statusCheckin !== 1
                        ? theme.colors.colorLocked
                        : theme.colors.darkGray
                    : 'transparent',
                [FORM_SCHEDULE_STATUS.PENDING_SYNC_IMAGE]: theme.colors.colorPending,
                [FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION]: theme.colors.colorPending,
            }[statusForm.status] || theme.colors.colorLocked

        const textColor =
            {
                [FORM_SCHEDULE_STATUS.BLOCKED]: theme.colors.colorLocked,
                [FORM_SCHEDULE_STATUS.PENDING]: theme.colors.colorPending,
                [FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION]: theme.colors.colorPending,
                [FORM_SCHEDULE_STATUS.COMPLETED]:
                    statusText(Math.round(statusForm.status)) === '100%' ? theme.colors.colorApproved : theme.colors.darkGray,
                [FORM_SCHEDULE_STATUS.PENDING_CONNECTION]:
                    statusText(Math.round(statusForm.status)) === '100%' ? theme.colors.textPrimary : theme.colors.alert,
            }[statusForm.status] || theme.colors.colorCancelled

        const labelBackgroundColor =
            {
                [FORM_SCHEDULE_STATUS.COMPLETED]: theme.colors.colorApproved,
                [FORM_SCHEDULE_STATUS.IN_PROGRESS]: theme.colors.colorInProgress,
                [FORM_SCHEDULE_STATUS.REFUSED]: theme.colors.colorCancelled,
                [FORM_SCHEDULE_STATUS.PENDING]: theme.colors.colorPending,
                [FORM_SCHEDULE_STATUS.PENDING_CONNECTION]: [CHECKIN_REALIZADO, CHECKOUT_REALIZADO].includes(statusCheckin)
                    ? theme.colors.alert
                    : theme.colors.colorApproved,
                [FORM_SCHEDULE_STATUS.PENDING_SYNC_IMAGE]: theme.colors.colorPending,
                [FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION]: 'transparent',
                // }[statusForm.status] || 'transparent'
            }[statusForm.status] || 'transparent'

        const labelBorderColor =
            {
                [FORM_SCHEDULE_STATUS.COMPLETED]: theme.colors.colorApproved,
                [FORM_SCHEDULE_STATUS.IN_PROGRESS]: theme.colors.colorInProgress,
                [FORM_SCHEDULE_STATUS.REFUSED]: theme.colors.colorCancelled,
                [FORM_SCHEDULE_STATUS.PENDING]: theme.colors.colorPending,
                [FORM_SCHEDULE_STATUS.PENDING_CONNECTION]: [CHECKIN_REALIZADO, CHECKOUT_REALIZADO].includes(statusCheckin)
                    ? theme.colors.alert
                    : theme.colors.colorApproved,
                [FORM_SCHEDULE_STATUS.PENDING_SYNC_IMAGE]: theme.colors.colorPending,
                [FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION]: theme.colors.colorPending,
            }[statusForm.status] || theme.colors.colorLocked

        const labelTextColor =
            {
                [FORM_SCHEDULE_STATUS.COMPLETED]: 'white',
                [FORM_SCHEDULE_STATUS.BLOCKED]: theme.colors.colorLocked,
                [FORM_SCHEDULE_STATUS.PENDING]: 'white',
                [FORM_SCHEDULE_STATUS.PENDING_CONNECTION]: statusCheckin === 1 ? theme.colors.textPrimary : 'white',
                [FORM_SCHEDULE_STATUS.PENDING_STATUS_FORM_MODERATION]: theme.colors.colorPending,
                [FORM_SCHEDULE_STATUS.IN_PROGRESS]: 'white',
            }[statusForm.status] || theme.colors.colorLocked
        const numberOfLines = name.includes(' ') ? 2 : 1
        return (
            <View style={[styles.containerItemsExecution, styleSet(statusForm.status, statusForm.repeat)]}>
                <TouchableOpacity
                    // style={[styles.alignCenter,  {flex: 1, width: (width - 92) / columns }]}
                    style={[styles.alignCenter, { flex: 1 }]}
                    disabled={false}
                    onPress={() => handleClickSet(statusForm.status, statusForm.repeat)}
                >
                    <View style={styles.containerProgress}>
                        {/* //Tenes que saber si va o no el progress si va progress esto de abajo va  sino va null */}
                        {(statusForm.status === FORM_SCHEDULE_STATUS.COMPLETED || statusForm.status === FORM_SCHEDULE_STATUS.PENDING_CONNECTION) &&
                            statusForm.progress_questions_yes_na > 0 && (
                                <Progress.Circle
                                    size={60}
                                    progress={statusForm.progress_questions_yes_na / 100}
                                    showsText={false}
                                    thickness={3}
                                    color={colorProgressCircle}
                                    unfilledColor={unfilledColorProgressCircle}
                                    borderWidth={0.1}
                                    borderColor={theme.colors.modalBackground}
                                    strokeCap='round'
                                />
                            )}
                        {/*statusForm.status != FORM_SCHEDULE_STATUS.COMPLETED && statusForm.status != FORM_SCHEDULE_STATUS.PENDING_CONNECTION && (*/}
                        {loading ? (
                            <Loader />
                        ) : formsWithPercentage(name) ? (
                            // <Image source={{ uri: null }} style={[styles.iconImageExecution, { tintColor: iconTintColor }]} resizeMode='contain' />
                            <>
                                {statusForm.status != FORM_SCHEDULE_STATUS.COMPLETED &&
                                    statusForm.status != FORM_SCHEDULE_STATUS.PENDING_CONNECTION && (
                                        <View
                                            style={{
                                                backgroundColor: theme.colors.storeFormButtonBackground,
                                                borderRadius: 40,
                                                position: 'absolute',
                                            }}
                                        >
                                            <Image
                                                source={{ uri: imageForm }}
                                                style={[styles.iconImageExecution, { tintColor: iconTintColor }]}
                                                resizeMode='contain'
                                            />
                                        </View>
                                    )}
                            </>
                        ) : (
                            <View style={{ backgroundColor: theme.colors.storeFormButtonBackground, borderRadius: 40, position: 'absolute' }}>
                                <Image
                                    source={{ uri: imageForm }}
                                    style={[styles.iconImageExecution, { tintColor: iconTintColor }]}
                                    resizeMode='contain'
                                />
                            </View>
                        )}
                        {/*)}*/}
                        {(statusForm.status === FORM_SCHEDULE_STATUS.COMPLETED || statusForm.status === FORM_SCHEDULE_STATUS.PENDING_CONNECTION) && (
                            <Text style={[styles.percentage, { color: textColor }]} numberOfLines={1}>
                                {statusText(Math.round(statusForm.status)) === languageFile.complete_mayus
                                    ? ''
                                    : statusText(Math.round(statusForm.status))}
                            </Text>
                        )}
                    </View>

                    <View style={styles.containerStatus}>
                        <View style={[styles.statusFormList, { backgroundColor: labelBackgroundColor, borderColor: labelBorderColor }]}>
                            <Text style={[styles.textStatus, { color: labelTextColor }]} numberOfLines={1}>
                                {statusForm.status === FORM_SCHEDULE_STATUS.COMPLETED || statusForm.status === FORM_SCHEDULE_STATUS.PENDING_CONNECTION
                                    ? languageFile.complete_mayus
                                    : statusText(Math.round(statusForm.status))}
                            </Text>
                        </View>
                    </View>
                    <Text style={styles.textNameExecution} numberOfLines={numberOfLines} ellipsizeMode='tail'>
                        {name}
                    </Text>
                </TouchableOpacity>
            </View>
        )
    },
)

const GotoForm = ({ data, closeBottomSheet, navigateToForms, indexForm, title, button = false, checkOut = () => {} }) => {
    const { languageFile } = getLanguage()

    const [enableButton, setEnableButton] = useState(false)

    const navigateForm = () => {
        navigateToForms(indexForm)
        closeBottomSheet(true)
    }

    const handleConfirm = async () => {
        setEnableButton(true)
        let Checkout = await checkOut()
        console.log('2219 --- CHECKOUT')

        closeBottomSheet(true) // Cerrar el BottomSheet si es necesario
        setEnableButton(false) // Habilitar el botón después de 10 segundos

        //closeBottomSheet(true)
        // setEnableButton(false)
    }
    const parts = data.message.split(':')
    const beforeColon = parts[0]
    const afterColon = parts[1]

    return (
        <View style={styles.contentContainer}>
            {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
            <View style={styles.messageContainer}>
                <View>
                    <Image style={styles.imageAsset} source={require('../../../assets/stores/checkOutLocked.png')} resizeMode='contain' />
                </View>
                {!button ? (
                    <View>
                        <Text style={styles.titleText}>{title}</Text>
                        <Text style={[styles.descriptionText, { paddingHorizontal: 12 }]}>{data.message}</Text>
                    </View>
                ) : (
                    <View>
                        <Text style={styles.titleText}>{title && title != '' ? title : languageFile.uncompleted_forms}</Text>
                        <Text style={styles.descriptionText}>{data.message}</Text>
                    </View>
                )}
            </View>

            <View style={styles.spacer} />

            <View style={styles.containerButton}>
                {!button && (
                    <TouchableOpacity
                        style={[
                            styles.button,
                            {
                                backgroundColor: theme.colors.colorPrimary,
                            },
                        ]}
                        onPress={() => navigateForm()}
                    >
                        <Text style={styles.textButton}>{languageFile.go_to_survey}</Text>
                    </TouchableOpacity>
                )}

                {button && (
                    <View>
                        <TouchableOpacity
                            style={[
                                styles.button,
                                {
                                    backgroundColor: enableButton ? theme.colors.colorLocked : theme.colors.colorPrimary,
                                },
                            ]}
                            onPress={() => handleConfirm()}
                            disabled={enableButton}
                        >
                            <Text style={styles.textButton}>{languageFile.check_out}</Text>
                        </TouchableOpacity>

                        <TouchableOpacity style={styles.buttonCancel} onPress={() => navigateForm()}>
                            <Text style={styles.textCancel}>{languageFile.go_to_survey}</Text>
                        </TouchableOpacity>
                    </View>
                )}
            </View>
        </View>
    )
}

const kpis_data = [
    {
        kpi: 'Cssi',
        value: 9.9,
        type: 'number',
    },
    {
        kpi: 'CSI % RTA',
        value: 20.6,
        type: 'percentage',
    },
    {
        kpi: 'SSI',
        value: 10,
        type: 'number',
    },
    {
        kpi: 'SSi % RTA',
        value: 33,
        type: 'percentage',
    },
]
